// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { PingControllerPingData, PingControllerPingResponses, PeopleControllerSearchData, PeopleControllerSearchResponses, PeopleControllerSearchErrors, V3PeopleControllerSearchData, V3PeopleControllerSearchResponses, V3PeopleControllerSearchErrors, V3InstitutionsControllerSearchData, V3InstitutionsControllerSearchResponses, V3InstitutionsControllerSearchErrors, CoreCrudControllerCreateData, CoreCrudControllerCreateResponses, CoreCrudControllerListData, CoreCrudControllerListResponses, CoreCrudControllerGetData, CoreCrudControllerGetResponses, CoreCrudControllerUpdateData, CoreCrudControllerUpdateResponses, CoreCrudControllerUpsertData, CoreCrudControllerUpsertResponses, CoreCrudControllerDeleteData, CoreCrudControllerDeleteResponses, CoreCrudControllerCountData, CoreCrudControllerCountResponses, ListCoverageInstitutionsControllerListCoverageInstitutionsData, ListCoverageInstitutionsControllerListCoverageInstitutionsResponses, ListCoverageInstitutionsControllerListCoverageInstitutionsErrors, ListCoverageGroupsControllerListCoverageGroupsData, ListCoverageGroupsControllerListCoverageGroupsResponses, ListCoverageGroupsControllerListCoverageGroupsErrors, GetCoverageMetricsControllerGetCoverageMetricsData, GetCoverageMetricsControllerGetCoverageMetricsResponses, GetCoverageMetricsControllerGetCoverageMetricsErrors, ListChildInstitutionsControllerListChildInstitutionsData, ListChildInstitutionsControllerListChildInstitutionsResponses, ListChildInstitutionsControllerListChildInstitutionsErrors, GetChildInstitutionsMetricsControllerGetChildInstitutionsMetricsData, GetChildInstitutionsMetricsControllerGetChildInstitutionsMetricsResponses, GetChildInstitutionsMetricsControllerGetChildInstitutionsMetricsErrors, InstitutionMatrixControllerGetInstitutionMatrixData, InstitutionMatrixControllerGetInstitutionMatrixResponses, GetInstitutionControllerGetInstitutionData, GetInstitutionControllerGetInstitutionResponses, GetInstitutionControllerGetInstitutionErrors, SearchInstitutionsControllerSearchData, SearchInstitutionsControllerSearchResponses, SearchInstitutionsControllerExportData, SearchInstitutionsControllerExportResponses, SearchInstitutionsControllerExportErrors, InstitutionUrlsControllerGetInstitutionUrlsData, InstitutionUrlsControllerGetInstitutionUrlsResponses, InstitutionUrlsControllerGetInstitutionUrlTypesData, InstitutionUrlsControllerGetInstitutionUrlTypesResponses, CrawlingJobsControllerGetCrawlingJobDefinitionData, CrawlingJobsControllerGetCrawlingJobDefinitionResponses, CrawlingJobsControllerGetCrawlingJobDefinitionErrors, CrawlingJobsControllerCreateCrawlingJobData, CrawlingJobsControllerCreateCrawlingJobResponses, CrawlingJobsControllerCreateCrawlingJobErrors, CreateTerritoryControllerCreateTerritoryData, CreateTerritoryControllerCreateTerritoryResponses, CreateTerritoryControllerCreateTerritoryErrors, GetTerritoryControllerGetTerritoryData, GetTerritoryControllerGetTerritoryResponses, GetTerritoryControllerGetTerritoryErrors, ListTerritoriesControllerListTerritoriesData, ListTerritoriesControllerListTerritoriesResponses, ListTerritoriesControllerListTerritoriesErrors, UpdateTerritoryControllerUpdateTerritoryData, UpdateTerritoryControllerUpdateTerritoryResponses, UpdateTerritoryControllerUpdateTerritoryErrors, DeleteTerritoryControllerDeleteTerritoryData, DeleteTerritoryControllerDeleteTerritoryResponses, DeleteTerritoryControllerDeleteTerritoryErrors, GetMeTeamControllerGetMeTeamData, GetMeTeamControllerGetMeTeamResponses, GetTeamControllerGetTeamData, GetTeamControllerGetTeamResponses, GetTeamControllerGetTeamErrors, ListTeamMembersControllerListTeamMembersData, ListTeamMembersControllerListTeamMembersResponses, ListTeamMembersControllerListTeamMembersErrors, RemoveTeamMemberControllerRemoveTeamMemberData, RemoveTeamMemberControllerRemoveTeamMemberResponses, RemoveTeamMemberControllerRemoveTeamMemberErrors, GetTeamDomainControllerGetTeamDomainData, GetTeamDomainControllerGetTeamDomainResponses, GetTeamDomainControllerGetTeamDomainErrors, ListDomainsControllerListDomainsData, ListDomainsControllerListDomainsResponses, ListDomainsControllerListDomainsErrors, GetTeamUsageControllerGetTeamUsageData, GetTeamUsageControllerGetTeamUsageResponses, GetTeamUsageControllerGetTeamUsageErrors, ListServiceLimitsControllerListServiceLimitsData, ListServiceLimitsControllerListServiceLimitsResponses, ListServiceLimitsControllerListServiceLimitsErrors, ListEventsControllerListEventsData, ListEventsControllerListEventsResponses, ListEventsControllerListEventsErrors, ListFeedItemsControllerListFeedItemsData, ListFeedItemsControllerListFeedItemsResponses, FeedItemsByHourControllerGetFeedItemsByHourData, FeedItemsByHourControllerGetFeedItemsByHourResponses, ListStreamItemsControllerListStreamItemsData, ListStreamItemsControllerListStreamItemsResponses, ListReceiptsControllerListReceiptsData, ListReceiptsControllerListReceiptsResponses, ListReceiptsControllerListReceiptsErrors, ListListsControllerListListsData, ListListsControllerListListsResponses, ListListsControllerListListsErrors, AddItemsToListControllerAddItemsToListData, AddItemsToListControllerAddItemsToListResponses, AddItemsToListControllerAddItemsToListErrors, RemoveItemsFromListControllerRemoveItemsFromListData, RemoveItemsFromListControllerRemoveItemsFromListResponses, RemoveItemsFromListControllerRemoveItemsFromListErrors, ArchiveExportControllerArchiveExportData, ArchiveExportControllerArchiveExportResponses, ArchiveExportControllerArchiveExportErrors, CopyExportControllerCopyExportData, CopyExportControllerCopyExportResponses, CopyExportControllerCopyExportErrors, CreateCompaniesExportControllerCreateCompaniesExportData, CreateCompaniesExportControllerCreateCompaniesExportResponses, CreateCompaniesExportControllerCreateCompaniesExportErrors, CreateExportControllerCreateExportData, CreateExportControllerCreateExportResponses, CreateExportControllerCreateExportErrors, GetExportControllerGetExportData, GetExportControllerGetExportResponses, GetExportControllerGetExportErrors, GetUnlockedInstitutionsStatsControllerGetUnlockedInstitutionsStatsData, GetUnlockedInstitutionsStatsControllerGetUnlockedInstitutionsStatsResponses, GetUnlockedInstitutionsStatsControllerGetUnlockedInstitutionsStatsErrors, UpdateExportControllerUpdateExportData, UpdateExportControllerUpdateExportResponses, UpdateExportControllerUpdateExportErrors, ExecuteExportControllerExecuteExportData, ExecuteExportControllerExecuteExportResponses, ExecuteExportControllerExecuteExportErrors, ListExportsControllerListExportsData, ListExportsControllerListExportsResponses, ListExportsControllerListExportsErrors, ListExportStatsControllerListExportStatsData, ListExportStatsControllerListExportStatsResponses, ListExportStatsControllerListExportStatsErrors, ListReviewErrorsControllerListReviewErrorsData, ListReviewErrorsControllerListReviewErrorsResponses, ListReviewErrorsControllerListReviewErrorsErrors, ListReviewRecordsControllerListReviewRecordsData, ListReviewRecordsControllerListReviewRecordsResponses, ListReviewRecordsControllerListReviewRecordsErrors, RetryReviewControllerRetryReviewData, RetryReviewControllerRetryReviewResponses, RetryReviewControllerRetryReviewErrors, UpdateReviewDecisionsControllerUpdateReviewDecisionsData, UpdateReviewDecisionsControllerUpdateReviewDecisionsResponses, UpdateReviewDecisionsControllerUpdateReviewDecisionsErrors, DownloadExportControllerDownloadExportData, DownloadExportControllerDownloadExportResponses, DownloadExportControllerDownloadExportErrors, DownloadExportReportControllerDownloadReportData, DownloadExportReportControllerDownloadReportResponses, DownloadExportReportControllerDownloadReportErrors, CreateExpansionRuleControllerCreateExpansionRuleData, CreateExpansionRuleControllerCreateExpansionRuleResponses, CreateExpansionRuleControllerCreateExpansionRuleErrors, GetExpansionRuleControllerGetExpansionRuleData, GetExpansionRuleControllerGetExpansionRuleResponses, GetExpansionRuleControllerGetExpansionRuleErrors, UpdateExpansionRuleControllerUpdateExpansionRuleData, UpdateExpansionRuleControllerUpdateExpansionRuleResponses, UpdateExpansionRuleControllerUpdateExpansionRuleErrors, ListExpansionRulesControllerListExpansionRulesData, ListExpansionRulesControllerListExpansionRulesResponses, ListExpansionRulesControllerListExpansionRulesErrors, TriggerExpansionRuleControllerTriggerExpansionRuleData, TriggerExpansionRuleControllerTriggerExpansionRuleResponses, TriggerExpansionRuleControllerTriggerExpansionRuleErrors, ListCustomersControllerListCustomersData, ListCustomersControllerListCustomersResponses, ListCustomersControllerListCustomersErrors, ListSignupsControllerListSignupsData, ListSignupsControllerListSignupsResponses, ListSignupsControllerListSignupsErrors, GetCustomerControllerGetCustomerData, GetCustomerControllerGetCustomerResponses, GetCustomerControllerGetCustomerErrors, ListUnlockedInstitutionsControllerListUnlockedInstitutionsData, ListUnlockedInstitutionsControllerListUnlockedInstitutionsResponses, ListUnlockedInstitutionsControllerListUnlockedInstitutionsErrors, AddSignupDomainControllerAddSignupDomainData, AddSignupDomainControllerAddSignupDomainResponses, AddSignupDomainControllerAddSignupDomainErrors, RemoveSignupDomainControllerRemoveSignupDomainData, RemoveSignupDomainControllerRemoveSignupDomainResponses, RemoveSignupDomainControllerRemoveSignupDomainErrors, AddTrackingDomainControllerAddTrackingDomainData, AddTrackingDomainControllerAddTrackingDomainResponses, AddTrackingDomainControllerAddTrackingDomainErrors, RemoveTrackingDomainControllerRemoveTrackingDomainData, RemoveTrackingDomainControllerRemoveTrackingDomainResponses, RemoveTrackingDomainControllerRemoveTrackingDomainErrors, SetUserOwnerControllerSetUserRoleData, SetUserOwnerControllerSetUserRoleResponses, SetUserOwnerControllerSetUserRoleErrors, SearchDistrictsControllerSearchDistrictsData, SearchDistrictsControllerSearchDistrictsResponses, ListDistrictsControllerListDistrictsData, ListDistrictsControllerListDistrictsResponses, GetDistrictGridMapControllerGetDistrictGridMapData, GetDistrictGridMapControllerGetDistrictGridMapResponses, ListDocumentsControllerListDocumentsData, ListDocumentsControllerListDocumentsResponses, GetDomainControllerGetDomainData, GetDomainControllerGetDomainResponses, GetDomainControllerGetDomainErrors, UpdateFilesControllerUpdateFilesData, UpdateFilesControllerUpdateFilesResponses, PresignedUploadUrlControllerGetPresignedUploadUrlData, PresignedUploadUrlControllerGetPresignedUploadUrlResponses, PresignedDownloadUrlControllerGetPresignedDownloadUrlData, PresignedDownloadUrlControllerGetPresignedDownloadUrlResponses, PresignedPreviewUrlControllerGetPresignedPreviewUrlData, PresignedPreviewUrlControllerGetPresignedPreviewUrlResponses, GetFileTextControllerGetFileTextData, GetFileTextControllerGetFileTextResponses, GetFileTextControllerGetFileTextErrors, GetTextByArnControllerGetTextByArnData, GetTextByArnControllerGetTextByArnResponses, CreateInternalFoiaControllerCreateInternalFoiaData, CreateInternalFoiaControllerCreateInternalFoiaResponses, CreateInternalFoiaControllerCreateInternalFoiaErrors, CreateFoiaJobControllerCreateFoiaJobData, CreateFoiaJobControllerCreateFoiaJobResponses, CreateFoiaJobControllerCreateFoiaJobErrors, ListFoiaJobsControllerListFoiaJobsData, ListFoiaJobsControllerListFoiaJobsResponses, ListFoiaJobsControllerListFoiaJobsErrors, GetFoiaJobControllerGetFoiaJobData, GetFoiaJobControllerGetFoiaJobResponses, UpdateFoiaJobStatusControllerUpdateFoiaJobStatusData, UpdateFoiaJobStatusControllerUpdateFoiaJobStatusResponses, UpdateFoiaJobItemStatusControllerUpdateFoiaJobItemStatusData, UpdateFoiaJobItemStatusControllerUpdateFoiaJobItemStatusResponses, DeleteFoiaArtifactControllerDeleteFoiaArtifactData, DeleteFoiaArtifactControllerDeleteFoiaArtifactResponses, CancelFoiaJobControllerCancelFoiaJobData, CancelFoiaJobControllerCancelFoiaJobResponses, CreateFoiaArtifactControllerCreateFoiaArtifactData, CreateFoiaArtifactControllerCreateFoiaArtifactResponses, FormSubmissionsControllerCreateFormSubmissionData, FormSubmissionsControllerCreateFormSubmissionResponses, FormSubmissionsControllerCreateFormSubmissionErrors, FormSubmissionsControllerListFormSubmissionsData, FormSubmissionsControllerListFormSubmissionsResponses, FormSubmissionsControllerListFormSubmissionsErrors, CleanupControllerCleanupData, CleanupControllerCleanupResponses, CleanupControllerCleanupErrors, ListRecordsControllerListRecordsData, ListRecordsControllerListRecordsResponses, ListRecordsControllerListRecordsErrors, ListRecordsControllerCountAllRecordsData, ListRecordsControllerCountAllRecordsResponses, ListRecordsControllerCountAllRecordsErrors, ListMembersControllerListMembersData, ListMembersControllerListMembersResponses, ListMembersControllerListMembersErrors, GetConnectionControllerGetConnectionData, GetConnectionControllerGetConnectionResponses, GetConnectionControllerGetConnectionErrors, ListFieldMappingsControllerListFieldMappingsData, ListFieldMappingsControllerListFieldMappingsResponses, ListFieldMappingsControllerListFieldMappingsErrors, CreateFieldMappingsControllerCreateFieldMappingsData, CreateFieldMappingsControllerCreateFieldMappingsResponses, CreateFieldMappingsControllerCreateFieldMappingsErrors, GetHubspotImportBatchControllerGetImportBatchData, GetHubspotImportBatchControllerGetImportBatchResponses, GetHubspotImportBatchControllerGetImportBatchErrors, OAuthInitiateControllerOauthInitiateData, OAuthInitiateControllerOauthInitiateResponses, OAuthInitiateControllerOauthInitiateErrors, OAuthCallbackControllerOauthCallbackData, OAuthCallbackControllerOauthCallbackResponses, OAuthCallbackControllerOauthCallbackErrors, DisconnectControllerDisconnectData, DisconnectControllerDisconnectResponses, DisconnectControllerDisconnectErrors, WebhookControllerHandleWebhookData, WebhookControllerHandleWebhookResponses, ListDealsControllerListDealsData, ListDealsControllerListDealsResponses, ListDealsControllerListDealsErrors, GetDealControllerGetDealData, GetDealControllerGetDealResponses, GetDealControllerGetDealErrors, ListDealSyncsControllerListDealSyncsData, ListDealSyncsControllerListDealSyncsResponses, ListDealSyncsControllerListDealSyncsErrors, CreateDealSyncControllerCreateDealSyncData, CreateDealSyncControllerCreateDealSyncResponses, CreateDealSyncControllerCreateDealSyncErrors, CreateMatchRunControllerCreateMatchRunData, CreateMatchRunControllerCreateMatchRunResponses, CreateMatchRunControllerCreateMatchRunErrors, GetMatchRunControllerGetMatchRunData, GetMatchRunControllerGetMatchRunResponses, GetMatchRunControllerGetMatchRunErrors, ListMatchRunsControllerListMatchRunsData, ListMatchRunsControllerListMatchRunsResponses, ListMatchRunsControllerListMatchRunsErrors, ListMatchRunRowsControllerListRowsData, ListMatchRunRowsControllerListRowsResponses, ListMatchRunRowsControllerListRowsErrors, SelectMatchRunRowsControllerSelectRowsData, SelectMatchRunRowsControllerSelectRowsResponses, SelectMatchRunRowsControllerSelectRowsErrors, CreateMatchRunExportControllerCreateExportData, CreateMatchRunExportControllerCreateExportResponses, CreateMatchRunExportControllerCreateExportErrors, ListIngestionDocumentsControllerListIngestionDocumentsData, ListIngestionDocumentsControllerListIngestionDocumentsResponses, GetIngestionDocumentControllerGetIngestionDocumentData, GetIngestionDocumentControllerGetIngestionDocumentResponses, ListIngestionDocumentCreatedEntitiesControllerListIngestionDocumentCreatedEntitiesData, ListIngestionDocumentCreatedEntitiesControllerListIngestionDocumentCreatedEntitiesResponses, SearchIngestionsControllerSearchData, SearchIngestionsControllerSearchResponses, SearchIngestionsControllerSearchErrors, SearchIngestionsControllerExportData, SearchIngestionsControllerExportResponses, SearchIngestionsControllerExportErrors, ApproveStagedContactsControllerApproveStagedContactsData, ApproveStagedContactsControllerApproveStagedContactsResponses, CreateStagedContactControllerCreateStagedContactData, CreateStagedContactControllerCreateStagedContactResponses, DeleteStagedContactControllerDeleteStagedContactData, DeleteStagedContactControllerDeleteStagedContactResponses, GetIntegrationsStatusControllerGetIntegrationsStatusData, GetIntegrationsStatusControllerGetIntegrationsStatusResponses, GetIntegrationsStatusControllerGetIntegrationsStatusErrors, OAuthInitiateControllerOauthInitiate2Data, OAuthInitiateControllerOauthInitiate2Responses, OAuthInitiateControllerOauthInitiate2Errors, SalesforceOAuthCallbackControllerOauthCallbackData, SalesforceOAuthCallbackControllerOauthCallbackResponses, SalesforceOAuthCallbackControllerOauthCallbackErrors, SalesforceGetConnectionControllerGetConnectionData, SalesforceGetConnectionControllerGetConnectionResponses, SalesforceGetConnectionControllerGetConnectionErrors, SalesforceDisconnectControllerDisconnectData, SalesforceDisconnectControllerDisconnectResponses, SalesforceDisconnectControllerDisconnectErrors, ListFieldMappingsControllerListFieldMappings2Data, ListFieldMappingsControllerListFieldMappings2Responses, ListFieldMappingsControllerListFieldMappings2Errors, CreateFieldMappingsControllerCreateFieldMappings2Data, CreateFieldMappingsControllerCreateFieldMappings2Responses, CreateFieldMappingsControllerCreateFieldMappings2Errors, ListAccountFieldMappingsControllerListAccountFieldMappingsData, ListAccountFieldMappingsControllerListAccountFieldMappingsResponses, ListAccountFieldMappingsControllerListAccountFieldMappingsErrors, CreateAccountFieldMappingsControllerCreateAccountFieldMappingsData, CreateAccountFieldMappingsControllerCreateAccountFieldMappingsResponses, CreateAccountFieldMappingsControllerCreateAccountFieldMappingsErrors, CreateCustomFieldControllerCreateCustomFieldData, CreateCustomFieldControllerCreateCustomFieldResponses, CreateCustomFieldControllerCreateCustomFieldErrors, MarkAppInstalledControllerMarkAppInstalledData, MarkAppInstalledControllerMarkAppInstalledResponses, MarkAppInstalledControllerMarkAppInstalledErrors, SalesforceCleanupControllerCleanupData, SalesforceCleanupControllerCleanupResponses, SalesforceCleanupControllerCleanupErrors, SalesforceCleanupControllerListRecordsData, SalesforceCleanupControllerListRecordsResponses, SalesforceCleanupControllerCountAllData, SalesforceCleanupControllerCountAllResponses, SalesforceCleanupControllerListAccountContactRelationsData, SalesforceCleanupControllerListAccountContactRelationsResponses, ListKeystoneEventsControllerListKeystoneEventsData, ListKeystoneEventsControllerListKeystoneEventsResponses, ListKeystoneEventsControllerListKeystoneEventsErrors, GetKeystoneEventControllerGetKeystoneEventData, GetKeystoneEventControllerGetKeystoneEventResponses, GetKeystoneEventControllerGetKeystoneEventErrors, GetContactPipelineControllerGetContactPipelineData, GetContactPipelineControllerGetContactPipelineResponses, GetContactPipelineControllerGetContactPipelineErrors, GetDecisionStatsControllerGetDecisionStatsData, GetDecisionStatsControllerGetDecisionStatsResponses, GetDecisionStatsControllerGetDecisionStatsErrors, GetEventQueueDepthControllerGetEventQueueDepthData, GetEventQueueDepthControllerGetEventQueueDepthResponses, GetEventQueueDepthControllerGetEventQueueDepthErrors, ListKeystoneContactsControllerListKeystoneContactsData, ListKeystoneContactsControllerListKeystoneContactsResponses, ListKeystoneContactsControllerListKeystoneContactsErrors, GetKeystoneContactControllerGetKeystoneContactData, GetKeystoneContactControllerGetKeystoneContactResponses, GetKeystoneContactControllerGetKeystoneContactErrors, ListKeystoneDerivedEventsControllerListKeystoneDerivedEventsData, ListKeystoneDerivedEventsControllerListKeystoneDerivedEventsResponses, GetKeystoneDerivedEventControllerGetKeystoneDerivedEventData, GetKeystoneDerivedEventControllerGetKeystoneDerivedEventResponses, ListKeystoneDecisionsControllerListKeystoneDecisionsData, ListKeystoneDecisionsControllerListKeystoneDecisionsResponses, ListKeystoneDecisionsControllerListKeystoneContactDecisionsData, ListKeystoneDecisionsControllerListKeystoneContactDecisionsResponses, GetKeystoneDecisionControllerGetKeystoneDecisionData, GetKeystoneDecisionControllerGetKeystoneDecisionResponses, GetKeystoneDecisionControllerGetKeystoneContactDecisionData, GetKeystoneDecisionControllerGetKeystoneContactDecisionResponses, ListKeystoneNormalizedContactsControllerListKeystoneNormalizedContactsData, ListKeystoneNormalizedContactsControllerListKeystoneNormalizedContactsResponses, ListKeystoneNormalizedContactsControllerListKeystoneNormalizedContactsErrors, GetKeystoneNormalizedContactControllerGetKeystoneNormalizedContactData, GetKeystoneNormalizedContactControllerGetKeystoneNormalizedContactResponses, GetKeystoneNormalizedContactControllerGetKeystoneNormalizedContactErrors, ListKeystoneTitlesControllerListKeystoneTitlesData, ListKeystoneTitlesControllerListKeystoneTitlesResponses, ListKeystoneTitlesControllerListKeystoneTitlesErrors, GetKeystoneTitleControllerGetKeystoneTitleData, GetKeystoneTitleControllerGetKeystoneTitleResponses, GetKeystoneTitleControllerGetKeystoneTitleErrors, UpdateKeystoneTitleControllerUpdateKeystoneTitleData, UpdateKeystoneTitleControllerUpdateKeystoneTitleResponses, UpdateKeystoneTitleControllerUpdateKeystoneTitleErrors, UpdateKeystoneTitleControllerDeleteKeystonePositionData, UpdateKeystoneTitleControllerDeleteKeystonePositionResponses, UpdateKeystoneTitleControllerDeleteKeystonePositionErrors, UpdateKeystoneTitleControllerUpdateKeystonePositionData, UpdateKeystoneTitleControllerUpdateKeystonePositionResponses, UpdateKeystoneTitleControllerUpdateKeystonePositionErrors, UpdateKeystoneTitleControllerAddKeystonePositionData, UpdateKeystoneTitleControllerAddKeystonePositionResponses, UpdateKeystoneTitleControllerAddKeystonePositionErrors, GetTitleEnumsControllerGetTitleEnumsData, GetTitleEnumsControllerGetTitleEnumsResponses, GetTitleEnumsControllerGetTitleEnumsErrors, ListProcessorRunsControllerListProcessorRunsData, ListProcessorRunsControllerListProcessorRunsResponses, ListEmailGuessesControllerListEmailGuessesData, ListEmailGuessesControllerListEmailGuessesResponses, ListSharedInboxesControllerListSharedInboxesData, ListSharedInboxesControllerListSharedInboxesResponses, GetProcessorRunControllerGetProcessorRunData, GetProcessorRunControllerGetProcessorRunResponses, ListLogsControllerListLogsData, ListLogsControllerListLogsResponses, ListMetricsSnapshotsControllerListMetricsSnapshotsData, ListMetricsSnapshotsControllerListMetricsSnapshotsResponses, ListMetricsSnapshotsControllerListMetricsSnapshotsErrors, ListDomainTypedUrlCountsControllerListDomainTypedUrlCountsData, ListDomainTypedUrlCountsControllerListDomainTypedUrlCountsResponses, ListDomainTypedUrlCountsControllerListDomainTypedUrlCountsErrors, GetPersonControllerGetPersonData, GetPersonControllerGetPersonResponses, GetPersonControllerGetPersonErrors, GetPersonActivityControllerGetPersonActivityData, GetPersonActivityControllerGetPersonActivityResponses, GetPersonActivityControllerGetPersonActivityErrors, SearchPeopleControllerSearchData, SearchPeopleControllerSearchResponses, SearchPeopleControllerExportData, SearchPeopleControllerExportResponses, SearchPeopleControllerExportErrors, PingControllerGetPingData, PingControllerGetPingResponses, PingControllerPostPingData, PingControllerPostPingResponses, PingControllerPostPingErrors, SuggestedFieldSelectionControllerGetSuggestedData, SuggestedFieldSelectionControllerGetSuggestedResponses, SuggestedFieldSelectionControllerGetSuggestedErrors, ListFieldSelectionsControllerListData, ListFieldSelectionsControllerListResponses, ListFieldSelectionsControllerListErrors, CreateFieldSelectionControllerCreateData, CreateFieldSelectionControllerCreateResponses, CreateFieldSelectionControllerCreateErrors, GetFieldSelectionControllerGetByIdData, GetFieldSelectionControllerGetByIdResponses, GetFieldSelectionControllerGetByIdErrors, ListSearchesControllerListSearchesData, ListSearchesControllerListSearchesResponses, ListSearchesControllerListSearchesErrors, ToggleStarControllerToggleStarData, ToggleStarControllerToggleStarResponses, ToggleStarControllerToggleStarErrors, DeleteSearchControllerArchiveSearchData, DeleteSearchControllerArchiveSearchResponses, DeleteSearchControllerArchiveSearchErrors, RenameSearchControllerRenameSearchData, RenameSearchControllerRenameSearchResponses, RenameSearchControllerRenameSearchErrors, ShareWithTeamControllerShareWithTeamData, ShareWithTeamControllerShareWithTeamResponses, ShareWithTeamControllerShareWithTeamErrors, UnshareFromTeamControllerUnshareFromTeamData, UnshareFromTeamControllerUnshareFromTeamResponses, UnshareFromTeamControllerUnshareFromTeamErrors, QueryLogControllerListTeamHistoryData, QueryLogControllerListTeamHistoryResponses, QueryLogControllerListUserHistoryData, QueryLogControllerListUserHistoryResponses, QueryLogControllerListGlobalHistoryData, QueryLogControllerListGlobalHistoryResponses, ApiUsageControllerGetDailyUsageData, ApiUsageControllerGetDailyUsageResponses, ApiUsageControllerGetDailyUsageErrors, ApiUsageControllerGetCallsData, ApiUsageControllerGetCallsResponses, ApiUsageControllerGetCallsErrors, DocumentationControllerGetOpenApiSchemaData, DocumentationControllerGetOpenApiSchemaResponses, VersionControllerGetVersionData, VersionControllerGetVersionResponses, ListWebhooksControllerListWebhooksData, ListWebhooksControllerListWebhooksResponses, ListWebhooksControllerListWebhooksErrors, CreateWebhookControllerCreateWebhookData, CreateWebhookControllerCreateWebhookResponses, CreateWebhookControllerCreateWebhookErrors, DeleteWebhookControllerDeleteWebhookData, DeleteWebhookControllerDeleteWebhookResponses, DeleteWebhookControllerDeleteWebhookErrors, ListWebhookEventsControllerListWebhookEventsData, ListWebhookEventsControllerListWebhookEventsResponses, ListWebhookEventsControllerListWebhookEventsErrors, NavigatorControllerGetNavigatorConfigData, NavigatorControllerGetNavigatorConfigResponses, GetMyPermissionsControllerGetMyPermissionsData, GetMyPermissionsControllerGetMyPermissionsResponses, LookupUrlControllerLookupUrlData, LookupUrlControllerLookupUrlResponses, LookupUrlControllerLookupUrlErrors, CreateUrlControllerCreateUrlData, CreateUrlControllerCreateUrlResponses, CreateUrlControllerCreateUrlErrors, UrlPrefixesControllerGetPrefixesForUrlData, UrlPrefixesControllerGetPrefixesForUrlResponses, GetUrlChangeLogDashboardControllerGetDashboardData, GetUrlChangeLogDashboardControllerGetDashboardResponses, DataGuardControllerListTicketsData, DataGuardControllerListTicketsResponses, DataGuardControllerGetTicketData, DataGuardControllerGetTicketResponses, DataGuardControllerResolveTicketData, DataGuardControllerResolveTicketResponses, DataGuardControllerUpdateTicketStatusData, DataGuardControllerUpdateTicketStatusResponses, DataGuardControllerMarkTicketWontFixData, DataGuardControllerMarkTicketWontFixResponses, DataGuardControllerMarkTicketFalsePositiveData, DataGuardControllerMarkTicketFalsePositiveResponses, DataGuardControllerBulkResolveTicketsData, DataGuardControllerBulkResolveTicketsResponses, DataGuardControllerBulkMarkFalsePositiveData, DataGuardControllerBulkMarkFalsePositiveResponses, DataGuardControllerListRunsData, DataGuardControllerListRunsResponses, DataGuardControllerGetRunData, DataGuardControllerGetRunResponses, DataGuardControllerListResolutionRunsData, DataGuardControllerListResolutionRunsResponses, DataGuardControllerGetResolutionRunData, DataGuardControllerGetResolutionRunResponses, DataGuardControllerGetSummaryStatsData, DataGuardControllerGetSummaryStatsResponses, DataGuardControllerGetGuardResolutionSchemaData, DataGuardControllerGetGuardResolutionSchemaResponses, DataGuardControllerListGuardsData, DataGuardControllerListGuardsResponses, DiagramsControllerListDiagramsData, DiagramsControllerListDiagramsResponses, DiagramsControllerGetDiagramData, DiagramsControllerGetDiagramResponses, DiagramsControllerGetDiagramErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Ping endpoint for V1 API
 * Simple ping endpoint to test V1 API connectivity
 */
export const pingControllerPing = <ThrowOnError extends boolean = false>(options?: Options<PingControllerPingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PingControllerPingResponses, unknown, ThrowOnError>({
        url: '/v1/ping',
        ...options
    });
};

/**
 * People search endpoint for V1 API
 * V1 endpoint for searching people - maintains backward compatibility
 */
export const peopleControllerSearch = <ThrowOnError extends boolean = false>(options?: Options<PeopleControllerSearchData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PeopleControllerSearchResponses, PeopleControllerSearchErrors, ThrowOnError>({
        url: '/v1/people/search',
        ...options
    });
};

/**
 * Search people
 * Search for people with flexible query conditions.
 *
 * ### Comma-Separated Values (OR Logic)
 *
 * The following operators support comma-separated values in the `value` field:
 * - **equals**: Matches if the field equals ANY of the provided values (OR logic)
 * - **not_equals**: Matches if the field equals NONE of the provided values (AND logic)
 * - **contains**: Matches if the field contains ANY of the provided values (OR logic)
 * - **does_not_contain**: Matches if the field contains NONE of the provided values (AND logic)
 *
 * **Example**: `{ field: "titleRole", operator: "equals", value: "principal,superintendent" }` matches people who are either principals OR superintendents.
 *
 * **Limits**: Maximum 40 comma-separated values per condition.
 *
 * ### Field-Operator Compatibility
 *
 * | Field | Supported Operators |
 * |-------|---------------------|
 * | name, email, phone, title, titleRole, titleArea, titleModifier, emailVerificationStatus | equals, not_equals, contains, does_not_contain, contains_word, starts_with, ends_with, exists, not_exists |
 * | titleRank | equals, not_equals, gt, gte, lt, lte, between |
 * | emailFormat, emailType, phoneUniqueness | equals, not_equals |
 * | labels | in, not_in |
 * | role.decisionLevel, role.functionalGroup | equals, not_equals, in |
 * | role.marketThemes | equals, not_equals, in, not_in |
 * | institution.id | equals |
 * | institution.name | equals, contains |
 * | institution.state, institution.access, institution.type, institution.ncesId, institution.titleOne | equals, not_equals |
 *
 * ### Field Data Types
 *
 * | Field | Type | Notes |
 * |-------|------|-------|
 * | name, email, phone, title | string | Text fields |
 * | emailVerificationStatus | string | Enum: valid, catch-all, invalid, abuse, do_not_mail |
 * | titleRole | string | Enum: superintendent, director, coordinator, manager, officer, specialist, supervisor, principal, counselor, dean, analyst, administrator, program specialist, hr generalist, assistant, professor, teacher, paraprofessional, member, custodian, coach, instructor, president, bus driver, nurse, librarian, tutor, paraeducator, trainer, aide, secretary, psychologist, staff, chair, registrar, therapist, treasurer, cook, social worker, pathologist, bookkeeper, faculty, developer, trustee, clerk, interventionist, receptionist, student, advisor, parent, diagnostician, cleaner, pastor, crossing guard, accountant, sponsor, technician, mechanic, educator, consultant, author, groundskeeper, moderator, interpreter, data processor, facilitator, engineer, recruiter, provost, chancellor, headmaster, attorney, counsel, clinician, physician, doctor, lecturer, liaison, mentor, advocate, fellow, strategist, planner, navigator, generalist, monitor, representative, driver, dispatcher, attendant, cashier, operator, inspector, guard, electrician, designer, editor, architect, artist, curator, webmaster, technologist, proctor, examiner, head, associate, lead, leader, commissioner, worker, intern, minister, guide, auditor, scientist, professional, translator, helper, typist, provider, founder, ceo, cfo, coo, cto, cio, cmo, cao, cbo, chro, cso, cdo, clo, cco, cpo, ciso |
 * | titleArea | string | Enum: special education, technology, human resources, student services, operations, curriculum and instruction, finance, facilities, transportation, admissions, athletics, development, communications, special services, food services, teaching and learning, advancement, education, maintenance, purchasing, accounting, security, enrollment, counseling, health services, federal programs, marketing, support services, music, student support, public information, information, elementary education, secondary education, schools, institutional advancement, alumni, board, board of directors, cafeteria, diversity equity inclusion, band, campus, academics, aquatics, special projects, department, science, social studies, speech, mathematics, spanish, language arts, custodial, history, library, business, revenue, attendance, reading, physical therapy, english, biology, choir, french, chemistry, administration, title 1, educational support, art, nursing, stem, cte, compliance, mental health, exceptional children, wellness, mtss, behavioral health, autism, social emotional learning, english language learner, physical education, fine arts, world languages, computer science, humanities, literacy, early childhood, adult education, alternative education, exceptional education, bilingual, instruction, assessment, testing, accountability, data, research, innovation, safety, student affairs, student success, college counseling, financial aid, intervention, occupational therapy, media, payroll, administrative services, business services, title ix, avid, special programs, accounts payable, nutrition, kitchen, health, guidance, curriculum, behavior, learning, performing arts, visual arts, basketball, football, volleyball, track, baseball, softball, soccer, swimming, tennis, golf, wrestling, cross country, boys, girls, engineering, instructional technology, edtech, digital learning, learning technology, audit, budget, campus ministry, religious education, faith formation, catechesis, youth ministry, childrens ministry, worship, liturgy, missions, discipleship, evangelization, pastoral care, spiritual life, spiritual formation, congregational care, annual giving, major gifts, planned giving, gift planning, donor relations, donor engagement, donor development, stewardship, grants, grants management, grants administration, philanthropy, fundraising, foundation relations, corporate relations, institutional giving, community engagement, community outreach, community relations, outreach, parent engagement, parent relations, family engagement, family relations, family services, partnerships, strategic partnerships, community partnerships, volunteer services, constituent relations, constituent engagement, government relations, legislative affairs, intergovernmental affairs, student life, campus life, residential life, student activities, co-curriculars, summer programs, summer camp, summer school, after school, aftercare, extended day, extended care, child care, childcare, daycare, child development, international programs, international students, global programs, gifted education, advanced academics, college readiness, college access, college success, career readiness, career pathways, postsecondary success, career services, career center, career development, college placement, workforce development, workforce training, talent, talent management, employee relations, benefits, total rewards, compensation, recruitment, professional development, professional learning, staff development, grounds, buildings and grounds, construction, new construction, capital projects, capital programs, fleet services, fleet maintenance, environmental services, warehouse, risk management, insurance, emergency management, utilities, energy, academic support, academic success, academic achievement, academic excellence, tutoring, transition services, disability services, disability resources, student accessibility, related services, specialized services, specialized learning, public relations, publicity, public affairs, external relations, external affairs, creative services, graphic design, video production, clinical services, medical services, therapy services, social work, theater, dance, arts education, strategic planning, strategic initiatives, strategic projects, strategic programs, policy, policy services, public policy, education policy, school improvement, school innovation, educator development, leadership development, organizational development, event services, conference services, veteran services, sustainability, outdoor education, legal services, 21st century, dyslexia, agriculture, plant science, animal science, natural resources, ffa, hospitality, tourism |
 * | titleModifier | string | Enum: assistant, associate, administrative, chief, executive, deputy, vice, senior, junior, lead, head, co, adjunct, visiting, distinguished, master, managing, supervising, regional, district, alternate, founding, special |
 * | titleRank | number | Numeric field (0-100, higher = more senior) |
 * | labels | array | Array of strings. Possible values: administrative support, communications staff, operations staff, decision maker, district leader, educator |
 * | emailFormat | string | Email pattern format (e.g., "{first}.{last}", "{f}{last}") |
 * | emailType | string | Enum: PERSONAL, SHARED, UNKNOWN |
 * | phoneUniqueness | string | Enum: UNIQUE, SHARED_CONTACT, SHARED_INSTITUTION, SHARED_CONTACT_INSTITUTION |
 * | role.decisionLevel | string | Enum: practitioner, school leadership, operational support, executive, functional leader |
 * | role.functionalGroup | string | Enum: student services, curriculum and instruction, special education, technology, finance and procurement, district administration, operations, human resources |
 * | role.marketThemes | array | Array of market themes. Values: athletics, accountability, career readiness, community and family engagement, diversity equity and inclusion, early learning, enrollment, gifted education, governance, facilities, finance, fine arts, human resources, literacy, mathematics, multilingual learner, professional development, public relations, school operations, science, social emotional learning, special education, stem, student health services, wellness, world languages, adult education, advancement, digital media, faith formation, instructional technology, international programs, intervention, library, physical education, social studies, strategic planning, student life, technology, agriculture, business marketing and finance, hospitality tourism and management |
 * | institution.id | string | UUID |
 * | institution.name | string | Text field |
 * | institution.state | string | 2-letter state code (e.g., "CA") |
 * | institution.access | string | Enum: PUBLIC, PRIVATE |
 * | institution.type | string | Enum: SCHOOL, DISTRICT |
 * | institution.ncesId | string | NCES identifier |
 * | institution.titleOne | boolean | true/false |
 */
export const v3PeopleControllerSearch = <ThrowOnError extends boolean = false>(options: Options<V3PeopleControllerSearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<V3PeopleControllerSearchResponses, V3PeopleControllerSearchErrors, ThrowOnError>({
        url: '/v3/people/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search institutions
 * Search for institutions with flexible query conditions.
 *
 * ### Comma-Separated Values (OR Logic)
 *
 * The following operators support comma-separated values in the `value` field:
 * - **equals**: Matches if the field equals ANY of the provided values (OR logic)
 * - **not_equals**: Matches if the field equals NONE of the provided values (AND logic)
 * - **contains**: Matches if the field contains ANY of the provided values (OR logic)
 * - **does_not_contain**: Matches if the field contains NONE of the provided values (AND logic)
 *
 * **Example**: `{ field: "state", operator: "equals", value: "CA,NY,TX" }` matches institutions in California OR New York OR Texas.
 *
 * **Limits**: Maximum 40 comma-separated values per condition.
 *
 * ### Field-Operator Compatibility
 *
 * | Field | Supported Operators |
 * |-------|---------------------|
 * | name, address, phone, fax | equals, not_equals, contains, does_not_contain, contains_word, starts_with, ends_with, exists, not_exists |
 * | type, subtype, model, ncesId, access, state, city, zip, religiousAffiliation, lowestGrade, highestGrade | equals, not_equals |
 * | studentsTotal, staffTotal, studentTeacherRatio, revenueTotal | equals, not_equals, gt, gte, lt, lte, between |
 * | titleOne, charterLea | equals, not_equals |
 *
 * ### Field Data Types
 *
 * | Field | Type | Notes |
 * |-------|------|-------|
 * | name, address, phone, fax | string | Text fields |
 * | type | string | Enum: SCHOOL, DISTRICT, STATE_AGENCY, etc. |
 * | subtype | string | Institution subtype |
 * | model | string | Institution model |
 * | ncesId | string | NCES identifier |
 * | access | string | Enum: PUBLIC, PRIVATE, CONSORTIUM |
 * | state | string | 2-letter state code (e.g., "CA") |
 * | city | string | City name |
 * | zip | string | ZIP code |
 * | religiousAffiliation | string | Religious affiliation if applicable |
 * | lowestGrade, highestGrade | string | Grade level (e.g., "K", "1", "12") |
 * | studentsTotal, staffTotal | number | Count of students/staff |
 * | studentTeacherRatio | number | Ratio (e.g., 15.5) |
 * | revenueTotal | number | Annual revenue in dollars |
 * | titleOne | boolean | Title I status (true/false) |
 * | charterLea | boolean | Charter LEA status (true/false) |
 */
export const v3InstitutionsControllerSearch = <ThrowOnError extends boolean = false>(options: Options<V3InstitutionsControllerSearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<V3InstitutionsControllerSearchResponses, V3InstitutionsControllerSearchErrors, ThrowOnError>({
        url: '/v3/institutions/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const coreCrudControllerCreate = <ThrowOnError extends boolean = false>(options: Options<CoreCrudControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoreCrudControllerCreateResponses, unknown, ThrowOnError>({
        url: '/core/{model}/create',
        ...options
    });
};

export const coreCrudControllerList = <ThrowOnError extends boolean = false>(options: Options<CoreCrudControllerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoreCrudControllerListResponses, unknown, ThrowOnError>({
        url: '/core/{model}/list',
        ...options
    });
};

export const coreCrudControllerGet = <ThrowOnError extends boolean = false>(options: Options<CoreCrudControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoreCrudControllerGetResponses, unknown, ThrowOnError>({
        url: '/core/{model}/get',
        ...options
    });
};

export const coreCrudControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<CoreCrudControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoreCrudControllerUpdateResponses, unknown, ThrowOnError>({
        url: '/core/{model}/update',
        ...options
    });
};

export const coreCrudControllerUpsert = <ThrowOnError extends boolean = false>(options: Options<CoreCrudControllerUpsertData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoreCrudControllerUpsertResponses, unknown, ThrowOnError>({
        url: '/core/{model}/upsert',
        ...options
    });
};

export const coreCrudControllerDelete = <ThrowOnError extends boolean = false>(options: Options<CoreCrudControllerDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoreCrudControllerDeleteResponses, unknown, ThrowOnError>({
        url: '/core/{model}/delete',
        ...options
    });
};

export const coreCrudControllerCount = <ThrowOnError extends boolean = false>(options: Options<CoreCrudControllerCountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoreCrudControllerCountResponses, unknown, ThrowOnError>({
        url: '/core/{model}/count',
        ...options
    });
};

/**
 * List coverage institutions grouped by rep
 * Returns all DISTRICT/REGULAR institutions grouped by rep. Supports sorting both at group and institution level.
 */
export const listCoverageInstitutionsControllerListCoverageInstitutions = <ThrowOnError extends boolean = false>(options: Options<ListCoverageInstitutionsControllerListCoverageInstitutionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListCoverageInstitutionsControllerListCoverageInstitutionsResponses, ListCoverageInstitutionsControllerListCoverageInstitutionsErrors, ThrowOnError>({
        url: '/coverage/institutions/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List coverage rep groups
 * Returns all available rep groups with institution counts
 */
export const listCoverageGroupsControllerListCoverageGroups = <ThrowOnError extends boolean = false>(options: Options<ListCoverageGroupsControllerListCoverageGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListCoverageGroupsControllerListCoverageGroupsResponses, ListCoverageGroupsControllerListCoverageGroupsErrors, ThrowOnError>({
        url: '/coverage-groups/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get coverage metrics
 * Returns metrics for institutions based on native or custom metric definitions. Includes historical data and dimensional breakdowns.
 */
export const getCoverageMetricsControllerGetCoverageMetrics = <ThrowOnError extends boolean = false>(options: Options<GetCoverageMetricsControllerGetCoverageMetricsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetCoverageMetricsControllerGetCoverageMetricsResponses, GetCoverageMetricsControllerGetCoverageMetricsErrors, ThrowOnError>({
        url: '/coverage/metrics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List child institutions for a parent
 * Returns all child institutions (schools) for a specified parent institution (district). Returns flat list without grouping.
 */
export const listChildInstitutionsControllerListChildInstitutions = <ThrowOnError extends boolean = false>(options: Options<ListChildInstitutionsControllerListChildInstitutionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListChildInstitutionsControllerListChildInstitutionsResponses, ListChildInstitutionsControllerListChildInstitutionsErrors, ThrowOnError>({
        url: '/coverage/institutions/{parentId}/children',
        ...options
    });
};

/**
 * Get metrics for child institutions
 * Returns metrics for child institutions (schools) of a specified parent institution (district). Includes historical data and dimensional breakdowns.
 */
export const getChildInstitutionsMetricsControllerGetChildInstitutionsMetrics = <ThrowOnError extends boolean = false>(options: Options<GetChildInstitutionsMetricsControllerGetChildInstitutionsMetricsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetChildInstitutionsMetricsControllerGetChildInstitutionsMetricsResponses, GetChildInstitutionsMetricsControllerGetChildInstitutionsMetricsErrors, ThrowOnError>({
        url: '/coverage/institutions/{parentId}/children/metrics',
        ...options
    });
};

/**
 * Get institution matrix data
 * Returns aggregated metrics for institutions with compact single-char keys. See response.keys for key mapping.
 */
export const institutionMatrixControllerGetInstitutionMatrix = <ThrowOnError extends boolean = false>(options?: Options<InstitutionMatrixControllerGetInstitutionMatrixData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<InstitutionMatrixControllerGetInstitutionMatrixResponses, unknown, ThrowOnError>({
        url: '/institutions/matrix',
        ...options
    });
};

/**
 * Get institution details
 * Returns details for a specific institution
 */
export const getInstitutionControllerGetInstitution = <ThrowOnError extends boolean = false>(options: Options<GetInstitutionControllerGetInstitutionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInstitutionControllerGetInstitutionResponses, GetInstitutionControllerGetInstitutionErrors, ThrowOnError>({
        url: '/institutions/{institutionId}',
        ...options
    });
};

export const searchInstitutionsControllerSearch = <ThrowOnError extends boolean = false>(options?: Options<SearchInstitutionsControllerSearchData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchInstitutionsControllerSearchResponses, unknown, ThrowOnError>({
        url: '/institutions/search',
        ...options
    });
};

/**
 * Export resources
 */
export const searchInstitutionsControllerExport = <ThrowOnError extends boolean = false>(options?: Options<SearchInstitutionsControllerExportData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchInstitutionsControllerExportResponses, SearchInstitutionsControllerExportErrors, ThrowOnError>({
        url: '/institutions/export',
        ...options
    });
};

/**
 * Get URLs for institution
 * Get all URLs associated with an institution via domains and URL prefixes. Only returns URLs where type is not null.
 */
export const institutionUrlsControllerGetInstitutionUrls = <ThrowOnError extends boolean = false>(options: Options<InstitutionUrlsControllerGetInstitutionUrlsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InstitutionUrlsControllerGetInstitutionUrlsResponses, unknown, ThrowOnError>({
        url: '/institutions/{id}/urls',
        ...options
    });
};

/**
 * Get distinct URL types for institution
 * Get all distinct URL types for an institution. Useful for populating filter dropdowns.
 */
export const institutionUrlsControllerGetInstitutionUrlTypes = <ThrowOnError extends boolean = false>(options: Options<InstitutionUrlsControllerGetInstitutionUrlTypesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InstitutionUrlsControllerGetInstitutionUrlTypesResponses, unknown, ThrowOnError>({
        url: '/institutions/{id}/url-types',
        ...options
    });
};

/**
 * Get crawling job definition
 * Fetches the crawling job definition JSON from S3
 */
export const crawlingJobsControllerGetCrawlingJobDefinition = <ThrowOnError extends boolean = false>(options: Options<CrawlingJobsControllerGetCrawlingJobDefinitionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CrawlingJobsControllerGetCrawlingJobDefinitionResponses, CrawlingJobsControllerGetCrawlingJobDefinitionErrors, ThrowOnError>({
        url: '/crawling-jobs/{id}/definition',
        ...options
    });
};

/**
 * Create a new crawling job
 * Creates a new crawling job from a list of URLs. The job will be uploaded to S3, stored in the database, and a Step Function execution will be triggered to start the crawl. Use GET /v2/core/crawling_jobs/:id to retrieve job details.
 */
export const crawlingJobsControllerCreateCrawlingJob = <ThrowOnError extends boolean = false>(options: Options<CrawlingJobsControllerCreateCrawlingJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CrawlingJobsControllerCreateCrawlingJobResponses, CrawlingJobsControllerCreateCrawlingJobErrors, ThrowOnError>({
        url: '/crawling-jobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a new territory
 * Creates a new territory with specified name and states
 */
export const createTerritoryControllerCreateTerritory = <ThrowOnError extends boolean = false>(options: Options<CreateTerritoryControllerCreateTerritoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTerritoryControllerCreateTerritoryResponses, CreateTerritoryControllerCreateTerritoryErrors, ThrowOnError>({
        url: '/territories/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific territory by ID
 * Returns details of a single territory by ID
 */
export const getTerritoryControllerGetTerritory = <ThrowOnError extends boolean = false>(options: Options<GetTerritoryControllerGetTerritoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTerritoryControllerGetTerritoryResponses, GetTerritoryControllerGetTerritoryErrors, ThrowOnError>({
        url: '/territories/{id}',
        ...options
    });
};

/**
 * List territories with filters and pagination
 * Returns territories with support for filtering, searching, and pagination
 */
export const listTerritoriesControllerListTerritories = <ThrowOnError extends boolean = false>(options: Options<ListTerritoriesControllerListTerritoriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListTerritoriesControllerListTerritoriesResponses, ListTerritoriesControllerListTerritoriesErrors, ThrowOnError>({
        url: '/territories/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update an existing territory
 * Updates territory name and/or states
 */
export const updateTerritoryControllerUpdateTerritory = <ThrowOnError extends boolean = false>(options: Options<UpdateTerritoryControllerUpdateTerritoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateTerritoryControllerUpdateTerritoryResponses, UpdateTerritoryControllerUpdateTerritoryErrors, ThrowOnError>({
        url: '/territories/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete territory
 * Deletes a territory by ID (Admin only)
 */
export const deleteTerritoryControllerDeleteTerritory = <ThrowOnError extends boolean = false>(options: Options<DeleteTerritoryControllerDeleteTerritoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTerritoryControllerDeleteTerritoryResponses, DeleteTerritoryControllerDeleteTerritoryErrors, ThrowOnError>({
        url: '/territories/{territoryId}',
        ...options
    });
};

/**
 * Get current user's team information
 * Returns the authenticated user's team details including configuration flags.
 */
export const getMeTeamControllerGetMeTeam = <ThrowOnError extends boolean = false>(options?: Options<GetMeTeamControllerGetMeTeamData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMeTeamControllerGetMeTeamResponses, unknown, ThrowOnError>({
        url: '/teams/me',
        ...options
    });
};

/**
 * Get team information by ID
 * Returns team details including configuration flags. Users can only access their own team data unless they are admins.
 */
export const getTeamControllerGetTeam = <ThrowOnError extends boolean = false>(options: Options<GetTeamControllerGetTeamData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTeamControllerGetTeamResponses, GetTeamControllerGetTeamErrors, ThrowOnError>({
        url: '/teams/{teamId}',
        ...options
    });
};

/**
 * List team members
 * Returns all members of the specified team from Cognito user pool
 */
export const listTeamMembersControllerListTeamMembers = <ThrowOnError extends boolean = false>(options: Options<ListTeamMembersControllerListTeamMembersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListTeamMembersControllerListTeamMembersResponses, ListTeamMembersControllerListTeamMembersErrors, ThrowOnError>({
        url: '/teams/{teamId}/members/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove team member
 * Removes a user from the team and disables their account.
 *
 * **Restrictions:**
 * - Only users with OWNER profile can remove team members
 * - Cannot remove yourself
 * - Cannot remove other OWNER users
 * - User must belong to your team
 */
export const removeTeamMemberControllerRemoveTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveTeamMemberControllerRemoveTeamMemberData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveTeamMemberControllerRemoveTeamMemberResponses, RemoveTeamMemberControllerRemoveTeamMemberErrors, ThrowOnError>({
        url: '/teams/{teamId}/members/{userId}',
        ...options
    });
};

/**
 * Get a team domain
 * Returns details for a specific domain associated with the specified team
 */
export const getTeamDomainControllerGetTeamDomain = <ThrowOnError extends boolean = false>(options: Options<GetTeamDomainControllerGetTeamDomainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTeamDomainControllerGetTeamDomainResponses, GetTeamDomainControllerGetTeamDomainErrors, ThrowOnError>({
        url: '/teams/{teamId}/domains/{domainId}',
        ...options
    });
};

/**
 * List team domains
 * Returns all domains associated with the authenticated team
 */
export const listDomainsControllerListDomains = <ThrowOnError extends boolean = false>(options: Options<ListDomainsControllerListDomainsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListDomainsControllerListDomainsResponses, ListDomainsControllerListDomainsErrors, ThrowOnError>({
        url: '/domains/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get team usage metrics
 * Returns usage metrics for a specific service limit type
 */
export const getTeamUsageControllerGetTeamUsage = <ThrowOnError extends boolean = false>(options: Options<GetTeamUsageControllerGetTeamUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetTeamUsageControllerGetTeamUsageResponses, GetTeamUsageControllerGetTeamUsageErrors, ThrowOnError>({
        url: '/teams/{teamId}/usage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List service limits for a team
 * Returns all service limits for the specified team including applied values, defaults, and sources (overrides, tier-based, or defaults). Users can only access their own team data unless they are admins.
 */
export const listServiceLimitsControllerListServiceLimits = <ThrowOnError extends boolean = false>(options: Options<ListServiceLimitsControllerListServiceLimitsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListServiceLimitsControllerListServiceLimitsResponses, ListServiceLimitsControllerListServiceLimitsErrors, ThrowOnError>({
        url: '/service-limits/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List events
 * Returns events
 */
export const listEventsControllerListEvents = <ThrowOnError extends boolean = false>(options: Options<ListEventsControllerListEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListEventsControllerListEventsResponses, ListEventsControllerListEventsErrors, ThrowOnError>({
        url: '/events/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List recently delivered feed items with cursor pagination
 */
export const listFeedItemsControllerListFeedItems = <ThrowOnError extends boolean = false>(options?: Options<ListFeedItemsControllerListFeedItemsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFeedItemsControllerListFeedItemsResponses, unknown, ThrowOnError>({
        url: '/feed/items',
        ...options
    });
};

/**
 * Feed item volume per hour, grouped by event type
 * Buckets feed items by the hour of deliver_after, which is when an item is scheduled to reach the feed rather than when it was created. Covers a window either side of now, so scheduled-but-undelivered items appear ahead of the current hour.
 */
export const feedItemsByHourControllerGetFeedItemsByHour = <ThrowOnError extends boolean = false>(options?: Options<FeedItemsByHourControllerGetFeedItemsByHourData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FeedItemsByHourControllerGetFeedItemsByHourResponses, unknown, ThrowOnError>({
        url: '/feed/items-by-hour',
        ...options
    });
};

/**
 * List updates for the contacts matching a saved search
 */
export const listStreamItemsControllerListStreamItems = <ThrowOnError extends boolean = false>(options: Options<ListStreamItemsControllerListStreamItemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStreamItemsControllerListStreamItemsResponses, unknown, ThrowOnError>({
        url: '/stream/{savedSearchId}/items',
        ...options
    });
};

/**
 * List receipts for a team
 * Returns Stripe receipts for a team. Requires team ownership or admin permissions.
 */
export const listReceiptsControllerListReceipts = <ThrowOnError extends boolean = false>(options: Options<ListReceiptsControllerListReceiptsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListReceiptsControllerListReceiptsResponses, ListReceiptsControllerListReceiptsErrors, ThrowOnError>({
        url: '/receipts/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all lists for a team
 * Returns all lists for the specified team filtered by type. Users can only access their own team data unless they are admins.
 */
export const listListsControllerListLists = <ThrowOnError extends boolean = false>(options: Options<ListListsControllerListListsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListListsControllerListListsResponses, ListListsControllerListListsErrors, ThrowOnError>({
        url: '/lists/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add items to a list
 * Adds the specified items to a list. Lists have a maximum of 1000 items. Users can only modify their own team lists unless they are admins.
 */
export const addItemsToListControllerAddItemsToList = <ThrowOnError extends boolean = false>(options: Options<AddItemsToListControllerAddItemsToListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddItemsToListControllerAddItemsToListResponses, AddItemsToListControllerAddItemsToListErrors, ThrowOnError>({
        url: '/lists/items/add',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove items from a list
 * Removes the specified items from a list. Users can only modify their own team lists unless they are admins.
 */
export const removeItemsFromListControllerRemoveItemsFromList = <ThrowOnError extends boolean = false>(options: Options<RemoveItemsFromListControllerRemoveItemsFromListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RemoveItemsFromListControllerRemoveItemsFromListResponses, RemoveItemsFromListControllerRemoveItemsFromListErrors, ThrowOnError>({
        url: '/lists/items/remove',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Archive an export
 * Archives an export that is in a non-final workflow status. Archived exports are hidden from the list by default.
 */
export const archiveExportControllerArchiveExport = <ThrowOnError extends boolean = false>(options: Options<ArchiveExportControllerArchiveExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ArchiveExportControllerArchiveExportResponses, ArchiveExportControllerArchiveExportErrors, ThrowOnError>({
        url: '/exports/{id}/archive',
        ...options
    });
};

/**
 * Copy an export to a new one
 * Creates a new export with the same query and entity as the source export, starting at TARGET_SELECTION status.
 */
export const copyExportControllerCopyExport = <ThrowOnError extends boolean = false>(options: Options<CopyExportControllerCopyExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CopyExportControllerCopyExportResponses, CopyExportControllerCopyExportErrors, ThrowOnError>({
        url: '/exports/{id}/copy',
        ...options
    });
};

/**
 * Create an institution export from missing companies
 * Creates a new INSTITUTION export containing all companies that are missing from the CRM in this contact export.
 */
export const createCompaniesExportControllerCreateCompaniesExport = <ThrowOnError extends boolean = false>(options: Options<CreateCompaniesExportControllerCreateCompaniesExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCompaniesExportControllerCreateCompaniesExportResponses, CreateCompaniesExportControllerCreateCompaniesExportErrors, ThrowOnError>({
        url: '/exports/{id}/create-companies-export',
        ...options
    });
};

/**
 * Create a new export
 * Creates a new export job. Provide either ids (for specific entities) or query (for filtered search), but not both.
 */
export const createExportControllerCreateExport = <ThrowOnError extends boolean = false>(options: Options<CreateExportControllerCreateExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateExportControllerCreateExportResponses, CreateExportControllerCreateExportErrors, ThrowOnError>({
        url: '/exports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get export by ID
 * Returns details of a specific export job including status, download URL, and metadata. Admin users can view exports from any team.
 */
export const getExportControllerGetExport = <ThrowOnError extends boolean = false>(options: Options<GetExportControllerGetExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetExportControllerGetExportResponses, GetExportControllerGetExportErrors, ThrowOnError>({
        url: '/exports/{exportId}',
        ...options
    });
};

/**
 * Get unlocked institutions stats for an export
 * Returns stats about how many institutions this export would unlock vs already unlocked
 */
export const getUnlockedInstitutionsStatsControllerGetUnlockedInstitutionsStats = <ThrowOnError extends boolean = false>(options: Options<GetUnlockedInstitutionsStatsControllerGetUnlockedInstitutionsStatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUnlockedInstitutionsStatsControllerGetUnlockedInstitutionsStatsResponses, GetUnlockedInstitutionsStatsControllerGetUnlockedInstitutionsStatsErrors, ThrowOnError>({
        url: '/exports/{exportId}/unlocked-institutions-stats',
        ...options
    });
};

/**
 * Update an export
 * Updates export target, field mappings, and/or options. Status auto-advances based on what is provided.
 */
export const updateExportControllerUpdateExport = <ThrowOnError extends boolean = false>(options: Options<UpdateExportControllerUpdateExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateExportControllerUpdateExportResponses, UpdateExportControllerUpdateExportErrors, ThrowOnError>({
        url: '/exports/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Execute an export
 * Triggers the export execution for an export that has completed review. Records marked as TAKE will be exported to the configured target.
 */
export const executeExportControllerExecuteExport = <ThrowOnError extends boolean = false>(options: Options<ExecuteExportControllerExecuteExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExecuteExportControllerExecuteExportResponses, ExecuteExportControllerExecuteExportErrors, ThrowOnError>({
        url: '/exports/{id}/execute',
        ...options
    });
};

/**
 * List exports
 * Returns all exports for the authenticated team (or specified team if teamId provided). Admins can omit teamId to list all exports across all teams.
 */
export const listExportsControllerListExports = <ThrowOnError extends boolean = false>(options: Options<ListExportsControllerListExportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListExportsControllerListExportsResponses, ListExportsControllerListExportsErrors, ThrowOnError>({
        url: '/exports/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get export statistics (Admin only)
 * Returns export statistics grouped by team, date, and status. Shows export counts aggregated by day. Admin only endpoint for monitoring export usage patterns.
 */
export const listExportStatsControllerListExportStats = <ThrowOnError extends boolean = false>(options: Options<ListExportStatsControllerListExportStatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListExportStatsControllerListExportStatsResponses, ListExportStatsControllerListExportStatsErrors, ThrowOnError>({
        url: '/exports/stats',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List unique export errors for an export
 * Returns unique error messages with counts across all review records
 */
export const listReviewErrorsControllerListReviewErrors = <ThrowOnError extends boolean = false>(options: Options<ListReviewErrorsControllerListReviewErrorsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListReviewErrorsControllerListReviewErrorsResponses, ListReviewErrorsControllerListReviewErrorsErrors, ThrowOnError>({
        url: '/exports/{exportId}/review-errors',
        ...options
    });
};

/**
 * List review records for an export
 * Returns paginated list of review records with their associations
 */
export const listReviewRecordsControllerListReviewRecords = <ThrowOnError extends boolean = false>(options: Options<ListReviewRecordsControllerListReviewRecordsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListReviewRecordsControllerListReviewRecordsResponses, ListReviewRecordsControllerListReviewRecordsErrors, ThrowOnError>({
        url: '/exports/{exportId}/review-records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retry the review preparation step
 * Clears existing review records and CRM matches, resets status, and re-triggers the review Step Function. Used after exporting companies to pick up newly created companies in the CRM.
 */
export const retryReviewControllerRetryReview = <ThrowOnError extends boolean = false>(options: Options<RetryReviewControllerRetryReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetryReviewControllerRetryReviewResponses, RetryReviewControllerRetryReviewErrors, ThrowOnError>({
        url: '/exports/{id}/retry-review',
        ...options
    });
};

/**
 * Update review decisions
 * Update user decisions for records (contacts, institutions, and associations)
 */
export const updateReviewDecisionsControllerUpdateReviewDecisions = <ThrowOnError extends boolean = false>(options: Options<UpdateReviewDecisionsControllerUpdateReviewDecisionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateReviewDecisionsControllerUpdateReviewDecisionsResponses, UpdateReviewDecisionsControllerUpdateReviewDecisionsErrors, ThrowOnError>({
        url: '/exports/{exportId}/review-decisions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get download URL for export
 * Returns a pre-signed S3 URL for downloading a specific export. The URL expires in 60 seconds. Admins can download exports from any team.
 */
export const downloadExportControllerDownloadExport = <ThrowOnError extends boolean = false>(options: Options<DownloadExportControllerDownloadExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadExportControllerDownloadExportResponses, DownloadExportControllerDownloadExportErrors, ThrowOnError>({
        url: '/exports/{exportId}/download',
        ...options
    });
};

/**
 * Download export status report
 * Returns a pre-signed S3 URL for downloading the status report showing SUCCESS/FAILED/SKIPPED for each record. Only available for Salesforce and HubSpot exports. Admins can download reports from any team.
 */
export const downloadExportReportControllerDownloadReport = <ThrowOnError extends boolean = false>(options: Options<DownloadExportReportControllerDownloadReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadExportReportControllerDownloadReportResponses, DownloadExportReportControllerDownloadReportErrors, ThrowOnError>({
        url: '/exports/{exportId}/report/download',
        ...options
    });
};

/**
 * Create a new expansion rule
 * Creates a new expansion rule with specified trigger event and filters
 */
export const createExpansionRuleControllerCreateExpansionRule = <ThrowOnError extends boolean = false>(options: Options<CreateExpansionRuleControllerCreateExpansionRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateExpansionRuleControllerCreateExpansionRuleResponses, CreateExpansionRuleControllerCreateExpansionRuleErrors, ThrowOnError>({
        url: '/expansion-rules/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get an expansion rule by ID
 * Retrieves an expansion rule by its ID. Returns 404 if not found or does not belong to the authenticated team.
 */
export const getExpansionRuleControllerGetExpansionRule = <ThrowOnError extends boolean = false>(options: Options<GetExpansionRuleControllerGetExpansionRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetExpansionRuleControllerGetExpansionRuleResponses, GetExpansionRuleControllerGetExpansionRuleErrors, ThrowOnError>({
        url: '/expansion-rules/{id}',
        ...options
    });
};

/**
 * Update an existing expansion rule
 * Updates an expansion rule with specified fields. Only provided fields will be updated.
 */
export const updateExpansionRuleControllerUpdateExpansionRule = <ThrowOnError extends boolean = false>(options: Options<UpdateExpansionRuleControllerUpdateExpansionRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateExpansionRuleControllerUpdateExpansionRuleResponses, UpdateExpansionRuleControllerUpdateExpansionRuleErrors, ThrowOnError>({
        url: '/expansion-rules/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List expansion rules
 * Returns expansion rules for the specified team with optional status filtering, sorting and pagination
 */
export const listExpansionRulesControllerListExpansionRules = <ThrowOnError extends boolean = false>(options: Options<ListExpansionRulesControllerListExpansionRulesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListExpansionRulesControllerListExpansionRulesResponses, ListExpansionRulesControllerListExpansionRulesErrors, ThrowOnError>({
        url: '/expansion-rules/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Manually trigger an expansion rule
 * Triggers an expansion rule for a specific NCES ID, creating a trigger record and expansion opportunity
 */
export const triggerExpansionRuleControllerTriggerExpansionRule = <ThrowOnError extends boolean = false>(options: Options<TriggerExpansionRuleControllerTriggerExpansionRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TriggerExpansionRuleControllerTriggerExpansionRuleResponses, TriggerExpansionRuleControllerTriggerExpansionRuleErrors, ThrowOnError>({
        url: '/expansion-rules/{ruleId}/trigger',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all customer teams
 * Returns all customer teams (excluding TRIAL and EXPIRED_TRIAL). Admin only endpoint.
 */
export const listCustomersControllerListCustomers = <ThrowOnError extends boolean = false>(options?: Options<ListCustomersControllerListCustomersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCustomersControllerListCustomersResponses, ListCustomersControllerListCustomersErrors, ThrowOnError>({
        url: '/customers/list',
        ...options
    });
};

/**
 * List all Cognito user signups
 * Returns all users from Cognito User Pool, sorted by creation date (newest first). Admin only endpoint.
 */
export const listSignupsControllerListSignups = <ThrowOnError extends boolean = false>(options?: Options<ListSignupsControllerListSignupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSignupsControllerListSignupsResponses, ListSignupsControllerListSignupsErrors, ThrowOnError>({
        url: '/customers/signups',
        ...options
    });
};

/**
 * Get customer details
 * Returns detailed information about a specific customer team. Admin only endpoint.
 */
export const getCustomerControllerGetCustomer = <ThrowOnError extends boolean = false>(options: Options<GetCustomerControllerGetCustomerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCustomerControllerGetCustomerResponses, GetCustomerControllerGetCustomerErrors, ThrowOnError>({
        url: '/customers/{teamId}',
        ...options
    });
};

/**
 * List unlocked institutions for a team
 * Returns paginated list of institutions that have been unlocked (exported) by a team.
 */
export const listUnlockedInstitutionsControllerListUnlockedInstitutions = <ThrowOnError extends boolean = false>(options: Options<ListUnlockedInstitutionsControllerListUnlockedInstitutionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListUnlockedInstitutionsControllerListUnlockedInstitutionsResponses, ListUnlockedInstitutionsControllerListUnlockedInstitutionsErrors, ThrowOnError>({
        url: '/customers/{teamId}/unlocked-institutions',
        ...options
    });
};

/**
 * Add signup domain to team
 * Adds a domain that auto-assigns new users to this team during signup. Admin only.
 */
export const addSignupDomainControllerAddSignupDomain = <ThrowOnError extends boolean = false>(options: Options<AddSignupDomainControllerAddSignupDomainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddSignupDomainControllerAddSignupDomainResponses, AddSignupDomainControllerAddSignupDomainErrors, ThrowOnError>({
        url: '/customers/{teamId}/signup-domains',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove signup domain from team
 * Removes a signup domain association from the team. Admin only.
 */
export const removeSignupDomainControllerRemoveSignupDomain = <ThrowOnError extends boolean = false>(options: Options<RemoveSignupDomainControllerRemoveSignupDomainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveSignupDomainControllerRemoveSignupDomainResponses, RemoveSignupDomainControllerRemoveSignupDomainErrors, ThrowOnError>({
        url: '/customers/{teamId}/signup-domains/{domain}',
        ...options
    });
};

/**
 * Add tracking domain to team
 * Adds a website domain for analytics tracking. Auto-generates eduleadSiteId. Admin only.
 */
export const addTrackingDomainControllerAddTrackingDomain = <ThrowOnError extends boolean = false>(options: Options<AddTrackingDomainControllerAddTrackingDomainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddTrackingDomainControllerAddTrackingDomainResponses, AddTrackingDomainControllerAddTrackingDomainErrors, ThrowOnError>({
        url: '/customers/{teamId}/tracking-domains',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove tracking domain from team
 * Removes a tracking domain from the team. Admin only.
 */
export const removeTrackingDomainControllerRemoveTrackingDomain = <ThrowOnError extends boolean = false>(options: Options<RemoveTrackingDomainControllerRemoveTrackingDomainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveTrackingDomainControllerRemoveTrackingDomainResponses, RemoveTrackingDomainControllerRemoveTrackingDomainErrors, ThrowOnError>({
        url: '/customers/{teamId}/tracking-domains/{domain}',
        ...options
    });
};

/**
 * Set user role
 * Sets the role for a user. Admin only endpoint.
 */
export const setUserOwnerControllerSetUserRole = <ThrowOnError extends boolean = false>(options: Options<SetUserOwnerControllerSetUserRoleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetUserOwnerControllerSetUserRoleResponses, SetUserOwnerControllerSetUserRoleErrors, ThrowOnError>({
        url: '/users/{userId}/role',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search districts
 * Search for districts by query string with usage tracking
 */
export const searchDistrictsControllerSearchDistricts = <ThrowOnError extends boolean = false>(options: Options<SearchDistrictsControllerSearchDistrictsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SearchDistrictsControllerSearchDistrictsResponses, unknown, ThrowOnError>({
        url: '/districts/search',
        ...options
    });
};

/**
 * List districts
 * List districts with pagination and optional state filter
 */
export const listDistrictsControllerListDistricts = <ThrowOnError extends boolean = false>(options: Options<ListDistrictsControllerListDistrictsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListDistrictsControllerListDistrictsResponses, unknown, ThrowOnError>({
        url: '/districts/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get district grid map
 * Returns the district grid map visualization data with ~18k districts positioned in a geographic grid layout
 */
export const getDistrictGridMapControllerGetDistrictGridMap = <ThrowOnError extends boolean = false>(options?: Options<GetDistrictGridMapControllerGetDistrictGridMapData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDistrictGridMapControllerGetDistrictGridMapResponses, unknown, ThrowOnError>({
        url: '/districts/grid-map',
        ...options
    });
};

/**
 * List documents
 * List documents with optional filtering by URL version run ID or user uploaded documents
 */
export const listDocumentsControllerListDocuments = <ThrowOnError extends boolean = false>(options: Options<ListDocumentsControllerListDocumentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListDocumentsControllerListDocumentsResponses, unknown, ThrowOnError>({
        url: '/documents/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get domain details
 * Returns details for a specific domain from Elasticsearch search database
 */
export const getDomainControllerGetDomain = <ThrowOnError extends boolean = false>(options: Options<GetDomainControllerGetDomainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDomainControllerGetDomainResponses, GetDomainControllerGetDomainErrors, ThrowOnError>({
        url: '/domains/{domainId}',
        ...options
    });
};

/**
 * Update files
 * Update multiple files by their IDs
 */
export const updateFilesControllerUpdateFiles = <ThrowOnError extends boolean = false>(options: Options<UpdateFilesControllerUpdateFilesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateFilesControllerUpdateFilesResponses, unknown, ThrowOnError>({
        url: '/files',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get presigned upload URL
 * Get a presigned URL for uploading a file to S3
 */
export const presignedUploadUrlControllerGetPresignedUploadUrl = <ThrowOnError extends boolean = false>(options: Options<PresignedUploadUrlControllerGetPresignedUploadUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PresignedUploadUrlControllerGetPresignedUploadUrlResponses, unknown, ThrowOnError>({
        url: '/files/presigned-upload-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get presigned download URL
 * Get a presigned URL for downloading a file from S3
 */
export const presignedDownloadUrlControllerGetPresignedDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<PresignedDownloadUrlControllerGetPresignedDownloadUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PresignedDownloadUrlControllerGetPresignedDownloadUrlResponses, unknown, ThrowOnError>({
        url: '/files/presigned-download-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get presigned preview URL
 * Get a presigned URL for previewing a file via Google Docs Viewer
 */
export const presignedPreviewUrlControllerGetPresignedPreviewUrl = <ThrowOnError extends boolean = false>(options: Options<PresignedPreviewUrlControllerGetPresignedPreviewUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PresignedPreviewUrlControllerGetPresignedPreviewUrlResponses, unknown, ThrowOnError>({
        url: '/files/presigned-preview-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get file text content
 * Returns the text content of a file from S3. Checks permissions based on file scope (PUBLIC/TEAM/PRIVATE).
 */
export const getFileTextControllerGetFileText = <ThrowOnError extends boolean = false>(options: Options<GetFileTextControllerGetFileTextData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFileTextControllerGetFileTextResponses, GetFileTextControllerGetFileTextErrors, ThrowOnError>({
        url: '/files/{fileId}/text',
        ...options
    });
};

/**
 * Get text content by ARN
 * Fetch text content directly from S3 using an ARN
 */
export const getTextByArnControllerGetTextByArn = <ThrowOnError extends boolean = false>(options: Options<GetTextByArnControllerGetTextByArnData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetTextByArnControllerGetTextByArnResponses, unknown, ThrowOnError>({
        url: '/files/get-text-by-arn',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create internal FOIA
 */
export const createInternalFoiaControllerCreateInternalFoia = <ThrowOnError extends boolean = false>(options: Options<CreateInternalFoiaControllerCreateInternalFoiaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateInternalFoiaControllerCreateInternalFoiaResponses, CreateInternalFoiaControllerCreateInternalFoiaErrors, ThrowOnError>({
        url: '/foia/response/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create FOIA job from district list
 */
export const createFoiaJobControllerCreateFoiaJob = <ThrowOnError extends boolean = false>(options: Options<CreateFoiaJobControllerCreateFoiaJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFoiaJobControllerCreateFoiaJobResponses, CreateFoiaJobControllerCreateFoiaJobErrors, ThrowOnError>({
        url: '/foia/requests/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List FOIA jobs
 */
export const listFoiaJobsControllerListFoiaJobs = <ThrowOnError extends boolean = false>(options: Options<ListFoiaJobsControllerListFoiaJobsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListFoiaJobsControllerListFoiaJobsResponses, ListFoiaJobsControllerListFoiaJobsErrors, ThrowOnError>({
        url: '/foia/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get FOIA job by ID
 */
export const getFoiaJobControllerGetFoiaJob = <ThrowOnError extends boolean = false>(options: Options<GetFoiaJobControllerGetFoiaJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetFoiaJobControllerGetFoiaJobResponses, unknown, ThrowOnError>({
        url: '/foia/get',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update FOIA job status
 */
export const updateFoiaJobStatusControllerUpdateFoiaJobStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateFoiaJobStatusControllerUpdateFoiaJobStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateFoiaJobStatusControllerUpdateFoiaJobStatusResponses, unknown, ThrowOnError>({
        url: '/foia/status/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update FOIA job item status
 */
export const updateFoiaJobItemStatusControllerUpdateFoiaJobItemStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateFoiaJobItemStatusControllerUpdateFoiaJobItemStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateFoiaJobItemStatusControllerUpdateFoiaJobItemStatusResponses, unknown, ThrowOnError>({
        url: '/foia/item/status/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete FOIA artifact
 */
export const deleteFoiaArtifactControllerDeleteFoiaArtifact = <ThrowOnError extends boolean = false>(options: Options<DeleteFoiaArtifactControllerDeleteFoiaArtifactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteFoiaArtifactControllerDeleteFoiaArtifactResponses, unknown, ThrowOnError>({
        url: '/foia/artifact/{artifactId}',
        ...options
    });
};

/**
 * Cancel a FOIA job
 */
export const cancelFoiaJobControllerCancelFoiaJob = <ThrowOnError extends boolean = false>(options: Options<CancelFoiaJobControllerCancelFoiaJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelFoiaJobControllerCancelFoiaJobResponses, unknown, ThrowOnError>({
        url: '/foia/jobs/{id}/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a FOIA artifact
 */
export const createFoiaArtifactControllerCreateFoiaArtifact = <ThrowOnError extends boolean = false>(options: Options<CreateFoiaArtifactControllerCreateFoiaArtifactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFoiaArtifactControllerCreateFoiaArtifactResponses, unknown, ThrowOnError>({
        url: '/foia/items/{itemId}/artifacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a form submission demo entry
 * Publicly accessible endpoint to create a demo form submission with email and browser information. Data is stored in DynamoDB for demonstration purposes.
 */
export const formSubmissionsControllerCreateFormSubmission = <ThrowOnError extends boolean = false>(options: Options<FormSubmissionsControllerCreateFormSubmissionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FormSubmissionsControllerCreateFormSubmissionResponses, FormSubmissionsControllerCreateFormSubmissionErrors, ThrowOnError>({
        url: '/form-submissions/demo/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List form submission demo entries (Super admin only)
 * Retrieves form submission demo entries from DynamoDB. Only accessible to admin users. Supports optional date filtering and limiting results.
 */
export const formSubmissionsControllerListFormSubmissions = <ThrowOnError extends boolean = false>(options: Options<FormSubmissionsControllerListFormSubmissionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FormSubmissionsControllerListFormSubmissionsResponses, FormSubmissionsControllerListFormSubmissionsErrors, ThrowOnError>({
        url: '/form-submissions/demo/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clean up HubSpot test data
 * Archives contacts and companies, and deletes lists created during E2E tests. Integration test accounts only.
 */
export const cleanupControllerCleanup = <ThrowOnError extends boolean = false>(options: Options<CleanupControllerCleanupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CleanupControllerCleanupResponses, CleanupControllerCleanupErrors, ThrowOnError>({
        url: '/hubspot/cleanup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List HubSpot records by IDs
 * Fetches contacts and companies from HubSpot by their IDs. Used to verify records exist during E2E tests. Integration test accounts only.
 */
export const listRecordsControllerListRecords = <ThrowOnError extends boolean = false>(options: Options<ListRecordsControllerListRecordsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListRecordsControllerListRecordsResponses, ListRecordsControllerListRecordsErrors, ThrowOnError>({
        url: '/hubspot/list-records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Count all HubSpot records
 * Returns the total count of contacts and companies in the HubSpot account. Used to verify cleanup during E2E tests. Integration test accounts only.
 */
export const listRecordsControllerCountAllRecords = <ThrowOnError extends boolean = false>(options?: Options<ListRecordsControllerCountAllRecordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListRecordsControllerCountAllRecordsResponses, ListRecordsControllerCountAllRecordsErrors, ThrowOnError>({
        url: '/hubspot/count-all',
        ...options
    });
};

/**
 * Get members of a HubSpot list
 * Returns all contact IDs that are members of the specified HubSpot list. Integration test accounts only.
 */
export const listMembersControllerListMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersControllerListMembersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListMembersControllerListMembersResponses, ListMembersControllerListMembersErrors, ThrowOnError>({
        url: '/hubspot/list-members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get HubSpot connection status
 * Returns the HubSpot connection status including account details and OAuth scope information
 */
export const getConnectionControllerGetConnection = <ThrowOnError extends boolean = false>(options?: Options<GetConnectionControllerGetConnectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetConnectionControllerGetConnectionResponses, GetConnectionControllerGetConnectionErrors, ThrowOnError>({
        url: '/hubspot/connection',
        ...options
    });
};

/**
 * List HubSpot field mappings
 * Returns all field mappings between Edulead and HubSpot fields for a team
 */
export const listFieldMappingsControllerListFieldMappings = <ThrowOnError extends boolean = false>(options: Options<ListFieldMappingsControllerListFieldMappingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListFieldMappingsControllerListFieldMappingsResponses, ListFieldMappingsControllerListFieldMappingsErrors, ThrowOnError>({
        url: '/hubspot/field-mappings/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create/update HubSpot field mappings
 * Creates or updates field mappings between Edulead and HubSpot fields for a team
 */
export const createFieldMappingsControllerCreateFieldMappings = <ThrowOnError extends boolean = false>(options: Options<CreateFieldMappingsControllerCreateFieldMappingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFieldMappingsControllerCreateFieldMappingsResponses, CreateFieldMappingsControllerCreateFieldMappingsErrors, ThrowOnError>({
        url: '/hubspot/field-mappings/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get HubSpot import batch details
 * Returns details of a specific HubSpot import batch by ID
 */
export const getHubspotImportBatchControllerGetImportBatch = <ThrowOnError extends boolean = false>(options: Options<GetHubspotImportBatchControllerGetImportBatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetHubspotImportBatchControllerGetImportBatchResponses, GetHubspotImportBatchControllerGetImportBatchErrors, ThrowOnError>({
        url: '/hubspot/imports/{importId}/batches/{batchId}',
        ...options
    });
};

/**
 * Initiate HubSpot OAuth flow
 * Generates a HubSpot OAuth URL with state parameter for CSRF protection
 */
export const oAuthInitiateControllerOauthInitiate = <ThrowOnError extends boolean = false>(options: Options<OAuthInitiateControllerOauthInitiateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OAuthInitiateControllerOauthInitiateResponses, OAuthInitiateControllerOauthInitiateErrors, ThrowOnError>({
        url: '/hubspot/oauth/initiate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Handle HubSpot OAuth callback
 * Exchanges the authorization code for access tokens and stores the connection
 */
export const oAuthCallbackControllerOauthCallback = <ThrowOnError extends boolean = false>(options: Options<OAuthCallbackControllerOauthCallbackData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OAuthCallbackControllerOauthCallbackResponses, OAuthCallbackControllerOauthCallbackErrors, ThrowOnError>({
        url: '/hubspot/oauth/callback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Disconnect HubSpot integration
 * Removes the HubSpot connection and deletes stored tokens
 */
export const disconnectControllerDisconnect = <ThrowOnError extends boolean = false>(options: Options<DisconnectControllerDisconnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DisconnectControllerDisconnectResponses, DisconnectControllerDisconnectErrors, ThrowOnError>({
        url: '/hubspot/disconnect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Receive HubSpot webhook events
 * Endpoint to receive webhook notifications from HubSpot for deal events
 */
export const webhookControllerHandleWebhook = <ThrowOnError extends boolean = false>(options: Options<WebhookControllerHandleWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<WebhookControllerHandleWebhookResponses, unknown, ThrowOnError>({
        url: '/hubspot/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List HubSpot deals
 * Retrieves a list of deals from HubSpot with optional filters for dealstage, amount, close date, and create date. Returns all deal properties by default.
 */
export const listDealsControllerListDeals = <ThrowOnError extends boolean = false>(options: Options<ListDealsControllerListDealsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListDealsControllerListDealsResponses, ListDealsControllerListDealsErrors, ThrowOnError>({
        url: '/hubspot/deals/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a HubSpot deal by ID
 * Retrieves a single deal from the local database by deal ID. Only returns deals belonging to the authenticated user's team.
 */
export const getDealControllerGetDeal = <ThrowOnError extends boolean = false>(options: Options<GetDealControllerGetDealData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDealControllerGetDealResponses, GetDealControllerGetDealErrors, ThrowOnError>({
        url: '/hubspot/deals/{id}',
        ...options
    });
};

/**
 * List HubSpot deal syncs
 * Retrieves a list of deal sync operations for a team from the local database.
 */
export const listDealSyncsControllerListDealSyncs = <ThrowOnError extends boolean = false>(options: Options<ListDealSyncsControllerListDealSyncsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListDealSyncsControllerListDealSyncsResponses, ListDealSyncsControllerListDealSyncsErrors, ThrowOnError>({
        url: '/hubspot/deal-syncs/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a HubSpot deal sync
 * Creates a new deal sync record in PENDING state and starts a Step Function execution to process the sync. Rate limited to 5 successful syncs per 24 hours. Only one sync can be active at a time per team.
 */
export const createDealSyncControllerCreateDealSync = <ThrowOnError extends boolean = false>(options: Options<CreateDealSyncControllerCreateDealSyncData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateDealSyncControllerCreateDealSyncResponses, CreateDealSyncControllerCreateDealSyncErrors, ThrowOnError>({
        url: '/hubspot/deal-syncs/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Start a HubSpot match run
 * Scans the connected HubSpot account and matches each company to one of our institutions. Returns immediately - the scan runs in the background and can take several minutes. Nothing is written back to HubSpot; matched institutions are handed to the export wizard.
 */
export const createMatchRunControllerCreateMatchRun = <ThrowOnError extends boolean = false>(options: Options<CreateMatchRunControllerCreateMatchRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMatchRunControllerCreateMatchRunResponses, CreateMatchRunControllerCreateMatchRunErrors, ThrowOnError>({
        url: '/hubspot/match-runs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a match run with its statistics
 * Returns the run, its match statistics, and the team's institution export limit so the results page can warn about the limit before an export is built rather than after.
 */
export const getMatchRunControllerGetMatchRun = <ThrowOnError extends boolean = false>(options: Options<GetMatchRunControllerGetMatchRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetMatchRunControllerGetMatchRunResponses, GetMatchRunControllerGetMatchRunErrors, ThrowOnError>({
        url: '/hubspot/match-runs/get',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List match runs
 * Match runs for the caller's team, newest first.
 */
export const listMatchRunsControllerListMatchRuns = <ThrowOnError extends boolean = false>(options: Options<ListMatchRunsControllerListMatchRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListMatchRunsControllerListMatchRunsResponses, ListMatchRunsControllerListMatchRunsErrors, ThrowOnError>({
        url: '/hubspot/match-runs/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the companies in a match run
 * Returns matched and unmatched companies alike - filter by matchStatus to separate them. Unmatched rows carry a failure reason and the closest institution we rejected, which is what makes a bad field mapping visible at a glance.
 */
export const listMatchRunRowsControllerListRows = <ThrowOnError extends boolean = false>(options: Options<ListMatchRunRowsControllerListRowsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListMatchRunRowsControllerListRowsResponses, ListMatchRunRowsControllerListRowsErrors, ThrowOnError>({
        url: '/hubspot/match-runs/rows/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Include or exclude rows from a match run
 * Takes either explicit row ids or a filter. The filter form is how a customer selects thousands of rows at once without the client sending every id.
 */
export const selectMatchRunRowsControllerSelectRows = <ThrowOnError extends boolean = false>(options: Options<SelectMatchRunRowsControllerSelectRowsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SelectMatchRunRowsControllerSelectRowsResponses, SelectMatchRunRowsControllerSelectRowsErrors, ThrowOnError>({
        url: '/hubspot/match-runs/rows/select',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create an export from a match run
 * Takes the selected matched institutions and creates an INSTITUTION export, then hand the caller to /exports/:id/target where the normal wizard takes over. The chosen rows are snapshotted, so re-filtering the run afterwards - or building a second export from it - cannot change what this export contains.
 */
export const createMatchRunExportControllerCreateExport = <ThrowOnError extends boolean = false>(options: Options<CreateMatchRunExportControllerCreateExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMatchRunExportControllerCreateExportResponses, CreateMatchRunExportControllerCreateExportErrors, ThrowOnError>({
        url: '/hubspot/match-runs/exports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List ingestion documents
 * List ingestion documents for a specific ingestion
 */
export const listIngestionDocumentsControllerListIngestionDocuments = <ThrowOnError extends boolean = false>(options: Options<ListIngestionDocumentsControllerListIngestionDocumentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListIngestionDocumentsControllerListIngestionDocumentsResponses, unknown, ThrowOnError>({
        url: '/ingestions/documents/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get ingestion document
 * Get a single ingestion document by ID with optional inference content
 */
export const getIngestionDocumentControllerGetIngestionDocument = <ThrowOnError extends boolean = false>(options: Options<GetIngestionDocumentControllerGetIngestionDocumentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetIngestionDocumentControllerGetIngestionDocumentResponses, unknown, ThrowOnError>({
        url: '/ingestions/documents/{id}',
        ...options
    });
};

/**
 * List ingestion document created entities
 * List entities (people) created by an ingestion document
 */
export const listIngestionDocumentCreatedEntitiesControllerListIngestionDocumentCreatedEntities = <ThrowOnError extends boolean = false>(options: Options<ListIngestionDocumentCreatedEntitiesControllerListIngestionDocumentCreatedEntitiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListIngestionDocumentCreatedEntitiesControllerListIngestionDocumentCreatedEntitiesResponses, unknown, ThrowOnError>({
        url: '/ingestions/documents/{id}/created-entities/list',
        ...options
    });
};

/**
 * Search resources
 */
export const searchIngestionsControllerSearch = <ThrowOnError extends boolean = false>(options?: Options<SearchIngestionsControllerSearchData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchIngestionsControllerSearchResponses, SearchIngestionsControllerSearchErrors, ThrowOnError>({
        url: '/ingestions/search',
        ...options
    });
};

/**
 * Export resources
 */
export const searchIngestionsControllerExport = <ThrowOnError extends boolean = false>(options?: Options<SearchIngestionsControllerExportData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchIngestionsControllerExportResponses, SearchIngestionsControllerExportErrors, ThrowOnError>({
        url: '/ingestions/export',
        ...options
    });
};

/**
 * Approve staged contacts
 * Approve all STAGED contacts for an ingestion document. Sets status to null and emits CONTACT_CREATED events.
 */
export const approveStagedContactsControllerApproveStagedContacts = <ThrowOnError extends boolean = false>(options: Options<ApproveStagedContactsControllerApproveStagedContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApproveStagedContactsControllerApproveStagedContactsResponses, unknown, ThrowOnError>({
        url: '/ingestions/documents/{id}/approve',
        ...options
    });
};

/**
 * Create a staged contact
 * Create a new contact with STAGED status linked to an ingestion document. Requires at least (name or title) and (phone or email).
 */
export const createStagedContactControllerCreateStagedContact = <ThrowOnError extends boolean = false>(options: Options<CreateStagedContactControllerCreateStagedContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateStagedContactControllerCreateStagedContactResponses, unknown, ThrowOnError>({
        url: '/ingestions/documents/{id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a staged contact
 * Delete a contact with status STAGED. Only staged contacts can be deleted.
 */
export const deleteStagedContactControllerDeleteStagedContact = <ThrowOnError extends boolean = false>(options: Options<DeleteStagedContactControllerDeleteStagedContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteStagedContactControllerDeleteStagedContactResponses, unknown, ThrowOnError>({
        url: '/ingestions/contacts/{id}',
        ...options
    });
};

/**
 * Get all integrations status
 * Returns the connection and configuration status of all integrations (HubSpot, Salesforce)
 */
export const getIntegrationsStatusControllerGetIntegrationsStatus = <ThrowOnError extends boolean = false>(options?: Options<GetIntegrationsStatusControllerGetIntegrationsStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetIntegrationsStatusControllerGetIntegrationsStatusResponses, GetIntegrationsStatusControllerGetIntegrationsStatusErrors, ThrowOnError>({
        url: '/integrations/status',
        ...options
    });
};

/**
 * Initiate Salesforce OAuth flow
 * Generates a Salesforce OAuth URL with state parameter for CSRF protection. Optionally accepts a custom Salesforce instance URL.
 */
export const oAuthInitiateControllerOauthInitiate2 = <ThrowOnError extends boolean = false>(options: Options<OAuthInitiateControllerOauthInitiate2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OAuthInitiateControllerOauthInitiate2Responses, OAuthInitiateControllerOauthInitiate2Errors, ThrowOnError>({
        url: '/salesforce/oauth/initiate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Handle Salesforce OAuth callback
 * Exchanges the authorization code for access tokens and stores the connection
 */
export const salesforceOAuthCallbackControllerOauthCallback = <ThrowOnError extends boolean = false>(options: Options<SalesforceOAuthCallbackControllerOauthCallbackData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SalesforceOAuthCallbackControllerOauthCallbackResponses, SalesforceOAuthCallbackControllerOauthCallbackErrors, ThrowOnError>({
        url: '/salesforce/oauth/callback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Salesforce connection status
 * Returns the Salesforce connection status including organization details and OAuth scope information
 */
export const salesforceGetConnectionControllerGetConnection = <ThrowOnError extends boolean = false>(options?: Options<SalesforceGetConnectionControllerGetConnectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SalesforceGetConnectionControllerGetConnectionResponses, SalesforceGetConnectionControllerGetConnectionErrors, ThrowOnError>({
        url: '/salesforce/connection',
        ...options
    });
};

/**
 * Disconnect Salesforce integration
 * Removes the Salesforce connection and deletes stored tokens
 */
export const salesforceDisconnectControllerDisconnect = <ThrowOnError extends boolean = false>(options: Options<SalesforceDisconnectControllerDisconnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SalesforceDisconnectControllerDisconnectResponses, SalesforceDisconnectControllerDisconnectErrors, ThrowOnError>({
        url: '/salesforce/disconnect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Salesforce field mappings
 * Returns all field mappings between Edulead and Salesforce fields for a team
 */
export const listFieldMappingsControllerListFieldMappings2 = <ThrowOnError extends boolean = false>(options: Options<ListFieldMappingsControllerListFieldMappings2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListFieldMappingsControllerListFieldMappings2Responses, ListFieldMappingsControllerListFieldMappings2Errors, ThrowOnError>({
        url: '/salesforce/field-mappings/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create/update Salesforce field mappings
 * Creates or updates field mappings between Edulead and Salesforce fields for a team
 */
export const createFieldMappingsControllerCreateFieldMappings2 = <ThrowOnError extends boolean = false>(options: Options<CreateFieldMappingsControllerCreateFieldMappings2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFieldMappingsControllerCreateFieldMappings2Responses, CreateFieldMappingsControllerCreateFieldMappings2Errors, ThrowOnError>({
        url: '/salesforce/field-mappings/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Salesforce account field mappings
 * Returns all field mappings between Edulead and Salesforce Account fields for a team
 */
export const listAccountFieldMappingsControllerListAccountFieldMappings = <ThrowOnError extends boolean = false>(options: Options<ListAccountFieldMappingsControllerListAccountFieldMappingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListAccountFieldMappingsControllerListAccountFieldMappingsResponses, ListAccountFieldMappingsControllerListAccountFieldMappingsErrors, ThrowOnError>({
        url: '/salesforce/account-field-mappings/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create/update Salesforce account field mappings
 * Creates or updates field mappings between Edulead and Salesforce Account fields for a team
 */
export const createAccountFieldMappingsControllerCreateAccountFieldMappings = <ThrowOnError extends boolean = false>(options: Options<CreateAccountFieldMappingsControllerCreateAccountFieldMappingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateAccountFieldMappingsControllerCreateAccountFieldMappingsResponses, CreateAccountFieldMappingsControllerCreateAccountFieldMappingsErrors, ThrowOnError>({
        url: '/salesforce/account-field-mappings/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a custom field in Salesforce
 * Creates a new custom field on the specified Salesforce object (Contact or Account)
 */
export const createCustomFieldControllerCreateCustomField = <ThrowOnError extends boolean = false>(options: Options<CreateCustomFieldControllerCreateCustomFieldData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCustomFieldControllerCreateCustomFieldResponses, CreateCustomFieldControllerCreateCustomFieldErrors, ThrowOnError>({
        url: '/salesforce/custom-fields',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark Salesforce app installation status
 */
export const markAppInstalledControllerMarkAppInstalled = <ThrowOnError extends boolean = false>(options: Options<MarkAppInstalledControllerMarkAppInstalledData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MarkAppInstalledControllerMarkAppInstalledResponses, MarkAppInstalledControllerMarkAppInstalledErrors, ThrowOnError>({
        url: '/salesforce/mark-app-installed',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clean up Salesforce test data
 * Deletes contacts and accounts created during E2E tests. Integration test accounts only.
 */
export const salesforceCleanupControllerCleanup = <ThrowOnError extends boolean = false>(options: Options<SalesforceCleanupControllerCleanupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SalesforceCleanupControllerCleanupResponses, SalesforceCleanupControllerCleanupErrors, ThrowOnError>({
        url: '/salesforce/cleanup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Salesforce records by ID
 * Fetches contacts and accounts from Salesforce by their IDs. Used for E2E test verification.
 */
export const salesforceCleanupControllerListRecords = <ThrowOnError extends boolean = false>(options: Options<SalesforceCleanupControllerListRecordsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SalesforceCleanupControllerListRecordsResponses, unknown, ThrowOnError>({
        url: '/salesforce/list-records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Count all Salesforce records
 * Returns the total count of contacts and accounts in the Salesforce org. Used for E2E test verification.
 */
export const salesforceCleanupControllerCountAll = <ThrowOnError extends boolean = false>(options?: Options<SalesforceCleanupControllerCountAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SalesforceCleanupControllerCountAllResponses, unknown, ThrowOnError>({
        url: '/salesforce/count-all',
        ...options
    });
};

/**
 * List AccountContactRelation records for contacts
 * Fetches AccountContactRelation records from Salesforce for given contact IDs. Used for E2E test verification of secondary account associations.
 */
export const salesforceCleanupControllerListAccountContactRelations = <ThrowOnError extends boolean = false>(options: Options<SalesforceCleanupControllerListAccountContactRelationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SalesforceCleanupControllerListAccountContactRelationsResponses, unknown, ThrowOnError>({
        url: '/salesforce/list-account-contact-relations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List keystone events
 * Returns paginated list of keystone events, ordered by created_at descending (newest first).
 */
export const listKeystoneEventsControllerListKeystoneEvents = <ThrowOnError extends boolean = false>(options: Options<ListKeystoneEventsControllerListKeystoneEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListKeystoneEventsControllerListKeystoneEventsResponses, ListKeystoneEventsControllerListKeystoneEventsErrors, ThrowOnError>({
        url: '/keystone/events/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get keystone event by ID
 * Returns a single keystone event with full payload.
 */
export const getKeystoneEventControllerGetKeystoneEvent = <ThrowOnError extends boolean = false>(options: Options<GetKeystoneEventControllerGetKeystoneEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKeystoneEventControllerGetKeystoneEventResponses, GetKeystoneEventControllerGetKeystoneEventErrors, ThrowOnError>({
        url: '/keystone/events/{id}',
        ...options
    });
};

/**
 * Get contact pipeline for a CONTACT_CREATED event
 * Traces a CONTACT_CREATED event through the entire keystone pipeline, returning all related data across tables.
 */
export const getContactPipelineControllerGetContactPipeline = <ThrowOnError extends boolean = false>(options: Options<GetContactPipelineControllerGetContactPipelineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetContactPipelineControllerGetContactPipelineResponses, GetContactPipelineControllerGetContactPipelineErrors, ThrowOnError>({
        url: '/keystone/pipeline/{eventId}',
        ...options
    });
};

/**
 * Get decision statistics by type
 * Returns decision counts from the decision_stats materialized view.
 */
export const getDecisionStatsControllerGetDecisionStats = <ThrowOnError extends boolean = false>(options?: Options<GetDecisionStatsControllerGetDecisionStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDecisionStatsControllerGetDecisionStatsResponses, GetDecisionStatsControllerGetDecisionStatsErrors, ThrowOnError>({
        url: '/keystone/decision-stats',
        ...options
    });
};

/**
 * Get pending event counts by type
 * Returns counts of pending events from the event_counts materialized view.
 */
export const getEventQueueDepthControllerGetEventQueueDepth = <ThrowOnError extends boolean = false>(options?: Options<GetEventQueueDepthControllerGetEventQueueDepthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEventQueueDepthControllerGetEventQueueDepthResponses, GetEventQueueDepthControllerGetEventQueueDepthErrors, ThrowOnError>({
        url: '/keystone/event-queue-depth',
        ...options
    });
};

/**
 * List keystone contacts
 * Returns paginated list of canonical contacts, ordered by created_at descending (newest first).
 */
export const listKeystoneContactsControllerListKeystoneContacts = <ThrowOnError extends boolean = false>(options: Options<ListKeystoneContactsControllerListKeystoneContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListKeystoneContactsControllerListKeystoneContactsResponses, ListKeystoneContactsControllerListKeystoneContactsErrors, ThrowOnError>({
        url: '/keystone/contacts/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get keystone contact by ID
 * Returns a single canonical contact with full details including normalized contacts, decisions, and derived events.
 */
export const getKeystoneContactControllerGetKeystoneContact = <ThrowOnError extends boolean = false>(options: Options<GetKeystoneContactControllerGetKeystoneContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKeystoneContactControllerGetKeystoneContactResponses, GetKeystoneContactControllerGetKeystoneContactErrors, ThrowOnError>({
        url: '/keystone/contacts/{id}',
        ...options
    });
};

/**
 * List keystone derived events with pagination
 */
export const listKeystoneDerivedEventsControllerListKeystoneDerivedEvents = <ThrowOnError extends boolean = false>(options: Options<ListKeystoneDerivedEventsControllerListKeystoneDerivedEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListKeystoneDerivedEventsControllerListKeystoneDerivedEventsResponses, unknown, ThrowOnError>({
        url: '/keystone/derived-events/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a keystone derived event by ID
 */
export const getKeystoneDerivedEventControllerGetKeystoneDerivedEvent = <ThrowOnError extends boolean = false>(options: Options<GetKeystoneDerivedEventControllerGetKeystoneDerivedEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKeystoneDerivedEventControllerGetKeystoneDerivedEventResponses, unknown, ThrowOnError>({
        url: '/keystone/derived-events/{id}',
        ...options
    });
};

/**
 * List keystone decisions with pagination
 */
export const listKeystoneDecisionsControllerListKeystoneDecisions = <ThrowOnError extends boolean = false>(options: Options<ListKeystoneDecisionsControllerListKeystoneDecisionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListKeystoneDecisionsControllerListKeystoneDecisionsResponses, unknown, ThrowOnError>({
        url: '/keystone/decisions/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List keystone contact decisions with pagination
 * Deprecated: Use POST /decisions/list instead
 * @deprecated
 */
export const listKeystoneDecisionsControllerListKeystoneContactDecisions = <ThrowOnError extends boolean = false>(options: Options<ListKeystoneDecisionsControllerListKeystoneContactDecisionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListKeystoneDecisionsControllerListKeystoneContactDecisionsResponses, unknown, ThrowOnError>({
        url: '/keystone/contact-decisions/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a keystone decision by ID
 */
export const getKeystoneDecisionControllerGetKeystoneDecision = <ThrowOnError extends boolean = false>(options: Options<GetKeystoneDecisionControllerGetKeystoneDecisionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKeystoneDecisionControllerGetKeystoneDecisionResponses, unknown, ThrowOnError>({
        url: '/keystone/decisions/{id}',
        ...options
    });
};

/**
 * Get a keystone contact decision by ID
 * Deprecated: Use GET /decisions/:id instead
 * @deprecated
 */
export const getKeystoneDecisionControllerGetKeystoneContactDecision = <ThrowOnError extends boolean = false>(options: Options<GetKeystoneDecisionControllerGetKeystoneContactDecisionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKeystoneDecisionControllerGetKeystoneContactDecisionResponses, unknown, ThrowOnError>({
        url: '/keystone/contact-decisions/{id}',
        ...options
    });
};

/**
 * List keystone normalized contacts
 * Returns paginated list of normalized contacts, ordered by created_at descending (newest first).
 */
export const listKeystoneNormalizedContactsControllerListKeystoneNormalizedContacts = <ThrowOnError extends boolean = false>(options: Options<ListKeystoneNormalizedContactsControllerListKeystoneNormalizedContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListKeystoneNormalizedContactsControllerListKeystoneNormalizedContactsResponses, ListKeystoneNormalizedContactsControllerListKeystoneNormalizedContactsErrors, ThrowOnError>({
        url: '/keystone/normalized-contacts/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get keystone normalized contact by ID
 * Returns a single normalized contact with full details including observations.
 */
export const getKeystoneNormalizedContactControllerGetKeystoneNormalizedContact = <ThrowOnError extends boolean = false>(options: Options<GetKeystoneNormalizedContactControllerGetKeystoneNormalizedContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKeystoneNormalizedContactControllerGetKeystoneNormalizedContactResponses, GetKeystoneNormalizedContactControllerGetKeystoneNormalizedContactErrors, ThrowOnError>({
        url: '/keystone/normalized-contacts/{id}',
        ...options
    });
};

/**
 * List keystone titles
 * Returns paginated list of normalized titles with their linked positions, ordered alphabetically.
 */
export const listKeystoneTitlesControllerListKeystoneTitles = <ThrowOnError extends boolean = false>(options: Options<ListKeystoneTitlesControllerListKeystoneTitlesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListKeystoneTitlesControllerListKeystoneTitlesResponses, ListKeystoneTitlesControllerListKeystoneTitlesErrors, ThrowOnError>({
        url: '/keystone/titles/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get keystone title by normalized_title
 * Returns a single keystone title with its linked positions.
 */
export const getKeystoneTitleControllerGetKeystoneTitle = <ThrowOnError extends boolean = false>(options: Options<GetKeystoneTitleControllerGetKeystoneTitleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetKeystoneTitleControllerGetKeystoneTitleResponses, GetKeystoneTitleControllerGetKeystoneTitleErrors, ThrowOnError>({
        url: '/keystone/titles/{normalizedTitle}',
        ...options
    });
};

/**
 * Update a keystone title
 * Updates fields like is_valid and parsed_by for a normalized title.
 */
export const updateKeystoneTitleControllerUpdateKeystoneTitle = <ThrowOnError extends boolean = false>(options: Options<UpdateKeystoneTitleControllerUpdateKeystoneTitleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateKeystoneTitleControllerUpdateKeystoneTitleResponses, UpdateKeystoneTitleControllerUpdateKeystoneTitleErrors, ThrowOnError>({
        url: '/keystone/titles/{normalizedTitle}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a keystone title position
 * Deletes a position from a title. At least one position must remain.
 */
export const updateKeystoneTitleControllerDeleteKeystonePosition = <ThrowOnError extends boolean = false>(options: Options<UpdateKeystoneTitleControllerDeleteKeystonePositionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<UpdateKeystoneTitleControllerDeleteKeystonePositionResponses, UpdateKeystoneTitleControllerDeleteKeystonePositionErrors, ThrowOnError>({
        url: '/keystone/titles/{normalizedTitle}/positions/{positionIndex}',
        ...options
    });
};

/**
 * Update a keystone title position
 * Updates position fields like role, area, modifier. Values are validated against enums.
 */
export const updateKeystoneTitleControllerUpdateKeystonePosition = <ThrowOnError extends boolean = false>(options: Options<UpdateKeystoneTitleControllerUpdateKeystonePositionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateKeystoneTitleControllerUpdateKeystonePositionResponses, UpdateKeystoneTitleControllerUpdateKeystonePositionErrors, ThrowOnError>({
        url: '/keystone/titles/{normalizedTitle}/positions/{positionIndex}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add a new position to a keystone title
 * Adds an empty position with auto-incremented index.
 */
export const updateKeystoneTitleControllerAddKeystonePosition = <ThrowOnError extends boolean = false>(options: Options<UpdateKeystoneTitleControllerAddKeystonePositionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateKeystoneTitleControllerAddKeystonePositionResponses, UpdateKeystoneTitleControllerAddKeystonePositionErrors, ThrowOnError>({
        url: '/keystone/titles/{normalizedTitle}/positions',
        ...options
    });
};

/**
 * Get title classification enums
 * Returns all title classification enums (modifier, role, area, status, level) with their synonyms.
 */
export const getTitleEnumsControllerGetTitleEnums = <ThrowOnError extends boolean = false>(options?: Options<GetTitleEnumsControllerGetTitleEnumsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTitleEnumsControllerGetTitleEnumsResponses, GetTitleEnumsControllerGetTitleEnumsErrors, ThrowOnError>({
        url: '/keystone/title-enums',
        ...options
    });
};

/**
 * List processor runs with pagination
 */
export const listProcessorRunsControllerListProcessorRuns = <ThrowOnError extends boolean = false>(options: Options<ListProcessorRunsControllerListProcessorRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListProcessorRunsControllerListProcessorRunsResponses, unknown, ThrowOnError>({
        url: '/keystone/processor-runs/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List generated email guesses with pagination and sorting
 */
export const listEmailGuessesControllerListEmailGuesses = <ThrowOnError extends boolean = false>(options: Options<ListEmailGuessesControllerListEmailGuessesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListEmailGuessesControllerListEmailGuessesResponses, unknown, ThrowOnError>({
        url: '/keystone/email-guesses/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List detected shared email inboxes with pagination and sorting
 */
export const listSharedInboxesControllerListSharedInboxes = <ThrowOnError extends boolean = false>(options: Options<ListSharedInboxesControllerListSharedInboxesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListSharedInboxesControllerListSharedInboxesResponses, unknown, ThrowOnError>({
        url: '/keystone/shared-inboxes/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a processor run by ID
 */
export const getProcessorRunControllerGetProcessorRun = <ThrowOnError extends boolean = false>(options: Options<GetProcessorRunControllerGetProcessorRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProcessorRunControllerGetProcessorRunResponses, unknown, ThrowOnError>({
        url: '/keystone/processor-runs/{id}',
        ...options
    });
};

/**
 * List logs
 * List logs from the last 12 hours
 */
export const listLogsControllerListLogs = <ThrowOnError extends boolean = false>(options?: Options<ListLogsControllerListLogsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ListLogsControllerListLogsResponses, unknown, ThrowOnError>({
        url: '/logs/list',
        ...options
    });
};

/**
 * List metrics snapshots
 * Returns metrics snapshots for the specified date range. Returns the most recent snapshot per day for each metric combination.
 */
export const listMetricsSnapshotsControllerListMetricsSnapshots = <ThrowOnError extends boolean = false>(options: Options<ListMetricsSnapshotsControllerListMetricsSnapshotsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListMetricsSnapshotsControllerListMetricsSnapshotsResponses, ListMetricsSnapshotsControllerListMetricsSnapshotsErrors, ThrowOnError>({
        url: '/metrics/snapshots/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List domains excluded from crawling by the typed URL limit
 * Returns the domains whose typed staff URL count exceeds MAX_TYPED_URLS_PER_DOMAIN and are therefore excluded from crawling and from URL metrics, plus the distribution of all institution domains by typed URL count. Read from the domain_typed_url_counts materialized view, which is refreshed daily, so these counts lag live data.
 */
export const listDomainTypedUrlCountsControllerListDomainTypedUrlCounts = <ThrowOnError extends boolean = false>(options: Options<ListDomainTypedUrlCountsControllerListDomainTypedUrlCountsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListDomainTypedUrlCountsControllerListDomainTypedUrlCountsResponses, ListDomainTypedUrlCountsControllerListDomainTypedUrlCountsErrors, ThrowOnError>({
        url: '/metrics/domain-typed-url-counts/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get person details
 * Returns details for a specific person/contact from Elasticsearch
 */
export const getPersonControllerGetPerson = <ThrowOnError extends boolean = false>(options: Options<GetPersonControllerGetPersonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPersonControllerGetPersonResponses, GetPersonControllerGetPersonErrors, ThrowOnError>({
        url: '/people/{personId}',
        ...options
    });
};

/**
 * List a contact's own activity
 * Derived events for one contact, newest first, in the same shape as a saved search's stream so both render through the same components. Filtered to the field changes worth showing on a detail page - see DEFAULT_CONTACT_ACTIVITY_FIELDS.
 */
export const getPersonActivityControllerGetPersonActivity = <ThrowOnError extends boolean = false>(options: Options<GetPersonActivityControllerGetPersonActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPersonActivityControllerGetPersonActivityResponses, GetPersonActivityControllerGetPersonActivityErrors, ThrowOnError>({
        url: '/people/{personId}/derived-events',
        ...options
    });
};

export const searchPeopleControllerSearch = <ThrowOnError extends boolean = false>(options?: Options<SearchPeopleControllerSearchData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchPeopleControllerSearchResponses, unknown, ThrowOnError>({
        url: '/people/search',
        ...options
    });
};

/**
 * Export resources
 */
export const searchPeopleControllerExport = <ThrowOnError extends boolean = false>(options?: Options<SearchPeopleControllerExportData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SearchPeopleControllerExportResponses, SearchPeopleControllerExportErrors, ThrowOnError>({
        url: '/people/export',
        ...options
    });
};

/**
 * Health check endpoint
 * Returns a simple ping response to verify the API is running
 */
export const pingControllerGetPing = <ThrowOnError extends boolean = false>(options?: Options<PingControllerGetPingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PingControllerGetPingResponses, unknown, ThrowOnError>({
        url: '/ping',
        ...options
    });
};

/**
 * Echo ping endpoint with status code testing
 * Returns a ping response with optional custom message. Can simulate different HTTP status codes for testing error handling.
 */
export const pingControllerPostPing = <ThrowOnError extends boolean = false>(options: Options<PingControllerPostPingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PingControllerPostPingResponses, PingControllerPostPingErrors, ThrowOnError>({
        url: '/ping',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get suggested field selection
 * Returns the most relevant field selection for the given entity and target. Returns the most recent selection for the team, or default mappings if none exist.
 */
export const suggestedFieldSelectionControllerGetSuggested = <ThrowOnError extends boolean = false>(options: Options<SuggestedFieldSelectionControllerGetSuggestedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SuggestedFieldSelectionControllerGetSuggestedResponses, SuggestedFieldSelectionControllerGetSuggestedErrors, ThrowOnError>({
        url: '/field-selections/suggested',
        ...options
    });
};

/**
 * List field selections
 * Returns a list of saved field selections for the team with optional filtering by entity and target.
 */
export const listFieldSelectionsControllerList = <ThrowOnError extends boolean = false>(options?: Options<ListFieldSelectionsControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFieldSelectionsControllerListResponses, ListFieldSelectionsControllerListErrors, ThrowOnError>({
        url: '/field-selections',
        ...options
    });
};

/**
 * Create a field selection
 * Creates a new field selection for the team. If an identical selection already exists (same checksum), returns the existing one.
 */
export const createFieldSelectionControllerCreate = <ThrowOnError extends boolean = false>(options: Options<CreateFieldSelectionControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFieldSelectionControllerCreateResponses, CreateFieldSelectionControllerCreateErrors, ThrowOnError>({
        url: '/field-selections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a field selection by ID
 * Returns a specific field selection by its ID. Admin users can view field selections from any team.
 */
export const getFieldSelectionControllerGetById = <ThrowOnError extends boolean = false>(options: Options<GetFieldSelectionControllerGetByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFieldSelectionControllerGetByIdResponses, GetFieldSelectionControllerGetByIdErrors, ThrowOnError>({
        url: '/field-selections/{id}',
        ...options
    });
};

/**
 * List search history
 * Returns search history for the current user in 3 categories: teamShared, starred, recent. If teamId is provided without entity (admin use), returns a flat list of all team searches.
 */
export const listSearchesControllerListSearches = <ThrowOnError extends boolean = false>(options: Options<ListSearchesControllerListSearchesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListSearchesControllerListSearchesResponses, ListSearchesControllerListSearchesErrors, ThrowOnError>({
        url: '/search-history/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Toggle star status
 * Stars or unstars a search history entry. Starred entries appear at the top of the list.
 */
export const toggleStarControllerToggleStar = <ThrowOnError extends boolean = false>(options: Options<ToggleStarControllerToggleStarData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ToggleStarControllerToggleStarResponses, ToggleStarControllerToggleStarErrors, ThrowOnError>({
        url: '/search-history/{id}/toggle-star',
        ...options
    });
};

/**
 * Archive search from history
 * Archives a search entry (soft delete) from the user's history.
 */
export const deleteSearchControllerArchiveSearch = <ThrowOnError extends boolean = false>(options: Options<DeleteSearchControllerArchiveSearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteSearchControllerArchiveSearchResponses, DeleteSearchControllerArchiveSearchErrors, ThrowOnError>({
        url: '/search-history/{id}',
        ...options
    });
};

/**
 * Rename a search
 * Updates the name of a search history entry.
 */
export const renameSearchControllerRenameSearch = <ThrowOnError extends boolean = false>(options: Options<RenameSearchControllerRenameSearchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<RenameSearchControllerRenameSearchResponses, RenameSearchControllerRenameSearchErrors, ThrowOnError>({
        url: '/search-history/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Share search with team
 * Shares a search history entry with the team. Only the owner can share their search.
 */
export const shareWithTeamControllerShareWithTeam = <ThrowOnError extends boolean = false>(options: Options<ShareWithTeamControllerShareWithTeamData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShareWithTeamControllerShareWithTeamResponses, ShareWithTeamControllerShareWithTeamErrors, ThrowOnError>({
        url: '/search-history/{id}/share',
        ...options
    });
};

/**
 * Unshare search from team
 * Removes a search history entry from team sharing. Only the user who shared it can unshare.
 */
export const unshareFromTeamControllerUnshareFromTeam = <ThrowOnError extends boolean = false>(options: Options<UnshareFromTeamControllerUnshareFromTeamData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnshareFromTeamControllerUnshareFromTeamResponses, UnshareFromTeamControllerUnshareFromTeamErrors, ThrowOnError>({
        url: '/search-history/{id}/unshare',
        ...options
    });
};

/**
 * List team query history
 * Returns the query history for the authenticated user's team
 */
export const queryLogControllerListTeamHistory = <ThrowOnError extends boolean = false>(options: Options<QueryLogControllerListTeamHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QueryLogControllerListTeamHistoryResponses, unknown, ThrowOnError>({
        url: '/query-log/team/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List user query history
 * Returns the query history for the authenticated user across all teams
 */
export const queryLogControllerListUserHistory = <ThrowOnError extends boolean = false>(options: Options<QueryLogControllerListUserHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QueryLogControllerListUserHistoryResponses, unknown, ThrowOnError>({
        url: '/query-log/user/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List global query history (admin only)
 * Returns the query history across all teams and users
 */
export const queryLogControllerListGlobalHistory = <ThrowOnError extends boolean = false>(options: Options<QueryLogControllerListGlobalHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QueryLogControllerListGlobalHistoryResponses, unknown, ThrowOnError>({
        url: '/query-log/global/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get daily API usage aggregation
 * Returns aggregated daily API usage counts for the last 90 days. Admin only.
 */
export const apiUsageControllerGetDailyUsage = <ThrowOnError extends boolean = false>(options: Options<ApiUsageControllerGetDailyUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiUsageControllerGetDailyUsageResponses, ApiUsageControllerGetDailyUsageErrors, ThrowOnError>({
        url: '/api-usage/{teamId}/daily',
        ...options
    });
};

/**
 * Get individual API calls
 * Returns individual API calls for the last 7 days. Admin only.
 */
export const apiUsageControllerGetCalls = <ThrowOnError extends boolean = false>(options: Options<ApiUsageControllerGetCallsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiUsageControllerGetCallsResponses, ApiUsageControllerGetCallsErrors, ThrowOnError>({
        url: '/api-usage/{teamId}/calls',
        ...options
    });
};

/**
 * Get OpenAPI schema
 * Returns the OpenAPI 3.0 schema for this API, suitable for use with Stoplight and other documentation tools
 */
export const documentationControllerGetOpenApiSchema = <ThrowOnError extends boolean = false>(options?: Options<DocumentationControllerGetOpenApiSchemaData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DocumentationControllerGetOpenApiSchemaResponses, unknown, ThrowOnError>({
        url: '/documentation/openapi',
        ...options
    });
};

/**
 * Get build version information
 */
export const versionControllerGetVersion = <ThrowOnError extends boolean = false>(options?: Options<VersionControllerGetVersionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<VersionControllerGetVersionResponses, unknown, ThrowOnError>({
        url: '/version',
        ...options
    });
};

/**
 * List webhooks
 * Returns all webhooks configured for the authenticated team
 */
export const listWebhooksControllerListWebhooks = <ThrowOnError extends boolean = false>(options: Options<ListWebhooksControllerListWebhooksData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListWebhooksControllerListWebhooksResponses, ListWebhooksControllerListWebhooksErrors, ThrowOnError>({
        url: '/webhooks/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create webhook
 * Creates a new webhook configuration for the team
 */
export const createWebhookControllerCreateWebhook = <ThrowOnError extends boolean = false>(options: Options<CreateWebhookControllerCreateWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateWebhookControllerCreateWebhookResponses, CreateWebhookControllerCreateWebhookErrors, ThrowOnError>({
        url: '/webhooks/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete webhook
 * Deletes a webhook configuration
 */
export const deleteWebhookControllerDeleteWebhook = <ThrowOnError extends boolean = false>(options: Options<DeleteWebhookControllerDeleteWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteWebhookControllerDeleteWebhookResponses, DeleteWebhookControllerDeleteWebhookErrors, ThrowOnError>({
        url: '/webhooks/{webhookId}',
        ...options
    });
};

/**
 * List webhook events
 * Returns the event history for a specific webhook
 */
export const listWebhookEventsControllerListWebhookEvents = <ThrowOnError extends boolean = false>(options: Options<ListWebhookEventsControllerListWebhookEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListWebhookEventsControllerListWebhookEventsResponses, ListWebhookEventsControllerListWebhookEventsErrors, ThrowOnError>({
        url: '/webhooks/{webhookId}/events/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const navigatorControllerGetNavigatorConfig = <ThrowOnError extends boolean = false>(options?: Options<NavigatorControllerGetNavigatorConfigData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<NavigatorControllerGetNavigatorConfigResponses, unknown, ThrowOnError>({
        url: '/navigator/config',
        ...options
    });
};

/**
 * Get current user permissions
 * Returns the effective permissions for the current user based on role, grants, and revokes.
 */
export const getMyPermissionsControllerGetMyPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetMyPermissionsControllerGetMyPermissionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMyPermissionsControllerGetMyPermissionsResponses, unknown, ThrowOnError>({
        url: '/permissions/me',
        ...options
    });
};

/**
 * Lookup URL by raw input
 * Accepts a raw URL, normalizes it on the backend, and looks it up in the database
 */
export const lookupUrlControllerLookupUrl = <ThrowOnError extends boolean = false>(options: Options<LookupUrlControllerLookupUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LookupUrlControllerLookupUrlResponses, LookupUrlControllerLookupUrlErrors, ThrowOnError>({
        url: '/urls/lookup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a new URL
 * Creates a new URL with normalization, classification, and anchor text handling. Uses URLService.saveUrls() internally.
 */
export const createUrlControllerCreateUrl = <ThrowOnError extends boolean = false>(options: Options<CreateUrlControllerCreateUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUrlControllerCreateUrlResponses, CreateUrlControllerCreateUrlErrors, ThrowOnError>({
        url: '/urls/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get URL prefixes that match a given URL
 * Find all institutions_urls_prefixes entries that match the provided URL. Uses efficient database query with server-side filtering.
 */
export const urlPrefixesControllerGetPrefixesForUrl = <ThrowOnError extends boolean = false>(options: Options<UrlPrefixesControllerGetPrefixesForUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UrlPrefixesControllerGetPrefixesForUrlResponses, unknown, ThrowOnError>({
        url: '/urls/{urlNormalized}/prefixes',
        ...options
    });
};

export const getUrlChangeLogDashboardControllerGetDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetUrlChangeLogDashboardControllerGetDashboardData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUrlChangeLogDashboardControllerGetDashboardResponses, unknown, ThrowOnError>({
        url: '/url-change-log/dashboard',
        ...options
    });
};

/**
 * List guard tickets with optional filters
 */
export const dataGuardControllerListTickets = <ThrowOnError extends boolean = false>(options?: Options<DataGuardControllerListTicketsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataGuardControllerListTicketsResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets',
        ...options
    });
};

/**
 * Get a single ticket by ID with resolution attempts
 */
export const dataGuardControllerGetTicket = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerGetTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataGuardControllerGetTicketResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets/{id}',
        ...options
    });
};

/**
 * Resolve a ticket with the provided resolution input
 * The resolution input must match the guard's Zod schema. The guard's resolve() method will be called to fix the underlying issue.
 */
export const dataGuardControllerResolveTicket = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerResolveTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DataGuardControllerResolveTicketResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets/{id}/resolve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update ticket status (e.g., OPEN to IN_PROGRESS)
 */
export const dataGuardControllerUpdateTicketStatus = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerUpdateTicketStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<DataGuardControllerUpdateTicketStatusResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark a ticket as won't fix
 */
export const dataGuardControllerMarkTicketWontFix = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerMarkTicketWontFixData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DataGuardControllerMarkTicketWontFixResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets/{id}/wont-fix',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark a ticket as false positive
 */
export const dataGuardControllerMarkTicketFalsePositive = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerMarkTicketFalsePositiveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DataGuardControllerMarkTicketFalsePositiveResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets/{id}/false-positive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk resolve tickets using their suggested resolutions
 * Resolves multiple tickets at once using each ticket's suggested_resolution. Max 50 tickets per call.
 */
export const dataGuardControllerBulkResolveTickets = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerBulkResolveTicketsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DataGuardControllerBulkResolveTicketsResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets/bulk-resolve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk mark tickets as false positive
 * Marks multiple tickets as false positive. Max 50 tickets per call.
 */
export const dataGuardControllerBulkMarkFalsePositive = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerBulkMarkFalsePositiveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DataGuardControllerBulkMarkFalsePositiveResponses, unknown, ThrowOnError>({
        url: '/data-guard/tickets/bulk-false-positive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List guard runs with optional filters
 */
export const dataGuardControllerListRuns = <ThrowOnError extends boolean = false>(options?: Options<DataGuardControllerListRunsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataGuardControllerListRunsResponses, unknown, ThrowOnError>({
        url: '/data-guard/runs',
        ...options
    });
};

/**
 * Get a single run by ID
 */
export const dataGuardControllerGetRun = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerGetRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataGuardControllerGetRunResponses, unknown, ThrowOnError>({
        url: '/data-guard/runs/{id}',
        ...options
    });
};

/**
 * List guard resolution runs with optional filters
 */
export const dataGuardControllerListResolutionRuns = <ThrowOnError extends boolean = false>(options?: Options<DataGuardControllerListResolutionRunsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataGuardControllerListResolutionRunsResponses, unknown, ThrowOnError>({
        url: '/data-guard/resolution-runs',
        ...options
    });
};

/**
 * Get a single resolution run by ID
 */
export const dataGuardControllerGetResolutionRun = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerGetResolutionRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataGuardControllerGetResolutionRunResponses, unknown, ThrowOnError>({
        url: '/data-guard/resolution-runs/{id}',
        ...options
    });
};

/**
 * Get summary statistics for the data guard system
 */
export const dataGuardControllerGetSummaryStats = <ThrowOnError extends boolean = false>(options?: Options<DataGuardControllerGetSummaryStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataGuardControllerGetSummaryStatsResponses, unknown, ThrowOnError>({
        url: '/data-guard/stats/summary',
        ...options
    });
};

/**
 * Get the resolution schema for a specific guard
 * Returns the Zod-derived JSON schema and UI field metadata for rendering resolution forms.
 */
export const dataGuardControllerGetGuardResolutionSchema = <ThrowOnError extends boolean = false>(options: Options<DataGuardControllerGetGuardResolutionSchemaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataGuardControllerGetGuardResolutionSchemaResponses, unknown, ThrowOnError>({
        url: '/data-guard/guards/{guardId}/resolution-schema',
        ...options
    });
};

/**
 * List all registered guards with metadata
 */
export const dataGuardControllerListGuards = <ThrowOnError extends boolean = false>(options?: Options<DataGuardControllerListGuardsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataGuardControllerListGuardsResponses, unknown, ThrowOnError>({
        url: '/data-guard/guards',
        ...options
    });
};

/**
 * List available diagrams
 */
export const diagramsControllerListDiagrams = <ThrowOnError extends boolean = false>(options?: Options<DiagramsControllerListDiagramsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DiagramsControllerListDiagramsResponses, unknown, ThrowOnError>({
        url: '/diagrams',
        ...options
    });
};

/**
 * Get diagram content by name
 */
export const diagramsControllerGetDiagram = <ThrowOnError extends boolean = false>(options: Options<DiagramsControllerGetDiagramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DiagramsControllerGetDiagramResponses, DiagramsControllerGetDiagramErrors, ThrowOnError>({
        url: '/diagrams/{name}',
        ...options
    });
};